/* =============================================================================
   RF: Custom Order Form (Framing Logic Phase 2)
   [FIX] Debug Log Control: console.log は window.RF_DEBUG = true 時のみ出力
   ============================================================================= */
(function() {
    if (!window._rfOrigConsoleLog) {
        window._rfOrigConsoleLog = console.log.bind(console);
        console.log = function() {
            if (window.RF_DEBUG) window._rfOrigConsoleLog.apply(console, arguments);
        };
    }
})();
if (!window.CustomOrderForm) {
    // [2026-07-17] お問い合わせ導線の共通機構。
    // 従来は mailto: を直接開いていたが、メールクライアント未設定の端末(スマホ/Webメール)では
    // 無反応のまま終わり問い合わせを取りこぼす。既存のお問い合わせフォーム(/pages/contact)へ
    // 誘導し、組み立てた本文を自動入力する方式に統一する。
    // 受け渡しは sessionStorage: URL に長文を載せず履歴/アクセスログを汚さないため。
    // 使用不可環境(プライベートモード等)では黙って素通りし、空フォームで継続できるようにする。
    const RF_CONTACT = {
        URL: '/pages/contact',
        KEY: 'rf_contact_prefill',
        // ネイティブ contact フォームには件名欄が無いので、件名は本文冒頭へ畳み込む。
        compose(subject, lines) {
            return [`【${subject}】`, ''].concat(lines).join('\n');
        },
        stash(text) {
            try { sessionStorage.setItem(this.KEY, text); } catch (e) { /* noop */ }
        },
        // 本文に出さない技術用 / Shopify 非表示キー(lead-time.js の _skipKey と同一基準)。
        _skipProp(k) {
            return k.charAt(0) === '_' || /ファイルアップロード|管理用|ダウンロード|入稿データURL|URL/.test(k);
        },
        // [2026-07-17] カート内の他の商品も本文に載せる。問い合わせは「目の前の1商品」ではなく
        // 「この注文」について来るため、カートを落とすとスタッフが全体像を掴めず往復が増える。
        // 取得失敗/遅延しても問い合わせ自体は落とさない(空文字を返して本文だけで続行)。
        cartSection() {
            const timeout = new Promise(resolve => setTimeout(() => resolve(''), 2000));
            const fetchCart = fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
                .then(r => (r.ok ? r.json() : null))
                .then(cart => {
                    if (!cart || !cart.items || !cart.items.length) return '';
                    const lines = ['', '', '【カートに入っている商品】'];   // 本文末尾との間に空行を入れて読みやすくする
                    cart.items.forEach((it, i) => {
                        const vt = (it.variant_title && it.variant_title !== 'Default Title') ? ` / ${it.variant_title}` : '';
                        lines.push(`${i + 1}. ${it.product_title || it.title} ${vt} × ${it.quantity}`.replace(/\s+/g, ' '));
                        const props = it.properties || {};
                        Object.keys(props).forEach(k => {
                            const v = (props[k] == null ? '' : String(props[k])).trim();
                            if (!v || this._skipProp(k)) return;
                            lines.push(`   ${k}: ${v}`);
                        });
                    });
                    return lines.join('\n') + '\n';
                })
                .catch(() => '');
            return Promise.race([fetchCart, timeout]);
        },
        // クリック時に最新の本文＋カート内容を退避してから /pages/contact へ遷移する <a> に仕立てる。
        // textFn は遅延評価(用紙選択後に余白・フチ処理等を入力しても反映させるため)。
        // カート取得が非同期なので既定遷移を止めて自前で飛ぶ。ここで例外を握り潰すと
        // 「押しても何も起きない」になるため、失敗時も必ず遷移させる。
        bind(link, textFn) {
            if (!link || link.dataset.rfInquiryBound) return link;
            link.dataset.rfInquiryBound = '1';
            link.href = this.URL;
            link.addEventListener('click', (e) => {
                e.preventDefault();
                let base = '';
                try { base = textFn(); } catch (err) { base = ''; }
                const go = (text) => { this.stash(text); window.location.href = this.URL; };
                this.cartSection().then(c => go(base + c)).catch(() => go(base));
            });
            return link;
        }
    };

    class CustomOrderForm extends window.RationalFuturismForm {
        constructor(formElement) {
            console.log("RF: CustomOrderForm Constructor Start");
            super(formElement);
            console.log("RF: CustomOrderForm Super Completed");

            this.config = window.rfConfig || {};
            console.log("RF: CustomOrderForm Config:", this.config);

            // Configuration & Cache
            this.paperMap = this.config.paperMap || {}; // { "PaperName": { "A4": 123, ... } }
            // [REFACTOR] Normalize customOptions: convert YEN string prices to Cents (number)
            const rawCustomOptions = this.config.customOptionVariants || [];
            this.customOptions = rawCustomOptions.map(v => {
                if (typeof v.price === 'string') {
                    return { ...v, price: parseInt(v.price.replace(/[^\d]/g, ''), 10) * 100 };
                }
                return v;
            });
            this.mainVariants = this.config.mainVariants || [];
            this.formType = this.config.formType;

            console.log("RF: Elements check:", this.elements);
            if (!this.elements) {
                console.error("RF: CRITICAL - this.elements is undefined! Parent constructor might have failed.");
                this.elements = {};
            }

            // Elements Cache
            this.elements.customShort = this.container.querySelector('#rf-size-short');
            this.elements.customLong = this.container.querySelector('#rf-size-long');
            this.elements.colorSection = this.container.querySelector('#rf-section-color');
            this.elements.paperSection = this.container.querySelector('#rf-section-paper');
            this.elements.windowSection = this.container.querySelector('#rf-section-window');
            this.elements.paperSelect = this.container.querySelector('#rf-paper-select');

            // Standard Sizes Definition (mm)
            if (window.rfConfig && window.rfConfig.mainVariants) {
                this.mainVariants = window.rfConfig.mainVariants;
            }
            // [NEW] Load Tags
            if (window.rfConfig && window.rfConfig.tags) {
                this.tags = window.rfConfig.tags;
            } else {
                this.tags = [];
            }

            this.StandardSizeDict = {
                'A0': [841, 1189], 'A1': [594, 841], 'A2': [420, 594], 'A3': [297, 420], 'A4': [210, 297],
                'B0': [1030, 1456], 'B1': [728, 1030], 'B2': [515, 728], 'B3': [364, 515], 'B4': [257, 364],
                '全紙': [457, 560], '半切': [356, 432], '四切': [254, 305], '六切': [203, 254],
                "大全紙": [508, 610], "全倍": [600, 900],
                "SM": [158, 227],
                "F4": [242, 333], "F6": [318, 410], "F8": [380, 455], "F10": [455, 530],
                "F15": [530, 652], "F20": [606, 727],
                "L": [89, 127], "ハガキ": [100, 148], "2L": [128, 178], "ワイド四切": [254, 365],
                // Square / Fixed (for explicit matching)
                "200x200": [200, 200], "300x300": [300, 300], "400x400": [400, 400],
                "500x500": [500, 500], "600x600": [600, 600], "800x800": [800, 800],
                "1000x1000": [1000, 1000], "1000x1500": [1000, 1500],
                "1000x2000": [1000, 2000], "1000x3000": [1000, 3000]
            };
            // Reuse for size logic
            this.STANDARD_SIZES = this.StandardSizeDict;

            console.log("RF: About to initFramingLogic");
            // Initialize Framing Logic after properties are set
            this.initFramingLogic();
            console.log("RF: initFramingLogic returned");

            this.initMainVariantListeners();

            // Recalculate total now that everything is initialized
            this.updateTotalDisplay();

            // ▼▼▼ 修正版: ページ全体(document)で変更を監視し、用途に応じて再計算 ▼▼▼
            document.addEventListener('change', (e) => {
                // 1. 無視すべき要素（サイズ選択とファイル、用紙サイズ選択、用紙モード切り替えは除外）
                if (e.target.id === 'rf-size-select' || e.target.id === 'rf-paper-size-select' || e.target.type === 'file' || e.target.name === 'rf-paper-size-mode') return;

                // 2. 加工タイプ変更 → フル再計算（用紙フィルタリング含む）
                const isProcessing = e.target.name === 'rf-processing-type';

                if (isProcessing) {
                    console.log(`RF: Processing Type Changed to [${e.target.value}]`);
                    if (['wood_unified', 'aluminum_unified', 'wood_panel', 'styrene_panel', 'canvas_panel'].includes(this.formType)) {
                        this.handleSizeSelectChange();
                    }
                    return;
                }

                // 3. [FIX] 価格に影響するが用紙リストには影響しないプロパティ → 価格再計算のみ
                // 用紙選択をリセットしないために handleSizeSelectChange は呼ばない
                const PRICE_ONLY_PROPERTIES = [
                    'properties[フレームカラー]',
                    'properties[側面カラー]',
                    'properties[テープカラー]',
                    'properties[側面テープカラー]',
                    'properties[マットカラー]',
                    'properties[印刷レイアウト]',
                    'properties[フチ処理]'
                ];
                const isPriceOnlyProperty = e.target.name && PRICE_ONLY_PROPERTIES.includes(e.target.name);

                if (isPriceOnlyProperty) {
                    console.log(`RF: Price-only Change on [${e.target.name}]. Value: ${e.target.value}`);
                    if (['wood_unified', 'aluminum_unified', 'wood_panel', 'styrene_panel', 'canvas_panel'].includes(this.formType)) {
                        // 価格再計算のみ（用紙リスト再構築なし）
                        const mainVariantInfo = this.getMainVariantAndPrice();
                        this.currentBasePrice = mainVariantInfo.price;
                        this.updateMainVariantId(mainVariantInfo.id);
                        this.updateTotalDisplay();
                    }
                }
            });
            // ▲▲▲ 修正ここまで ▲▲▲

            // ▼▼▼ 追加: 用紙ロジックを起動する ▼▼▼
            if (typeof this.initPaperLogic === 'function') {
                this.initPaperLogic();
            }

            // [FIX] Paper Map の非同期ロードを即座に開始
            // Liquid の collections.all limit:250 では用紙商品がヒットしない場合があるため、
            // JSON ファイルからの取得を初期化時に必ず行う
            this.loadPaperAvailabilityMap();

            // [FIX] Fetch Custom Option Data Async to avoid Liquid limits (250 items)
            this.fetchCustomOptionData().then(() => {
                console.log("RF: Custom Option Data Loaded Async via JS");
                // Re-calc if in custom mode
                if (this.isCustomMode) {
                    this.updateCustomCalculation();
                    this.updateTotalDisplay();
                }

                // [NEW] Dynamic Numbering after everything is loaded and visibility is stable
                setTimeout(() => this.updateStepNumbers(), 50);
            });

            console.log("RF: Constructor End");
        }

        // [New Helper] Fetch Custom Option Data (Static JSON from Assets)
        async fetchCustomOptionData() {
            console.log("RF: fetchCustomOptionData START (Static JSON Mode)");

            const url = window.rfConfig ? window.rfConfig.customOptionsJsonUrl : null;
            if (!url) {
                console.error("RF: Custom Options JSON URL not found in config.");
                return;
            }

            try {
                console.log(`RF: Fetching Custom Option Data from Assets... URL: ${url}`);
                const res = await fetch(url); // Standard fetch for static file
                if (!res.ok) throw new Error(`Status ${res.status}`);

                const variants = await res.json();

                if (variants && Array.isArray(variants)) {
                    // [REFACTOR] Normalize Price to cents immediately to match Shopify Liquid standard
                    this.customOptions = variants.map(v => {
                        if (typeof v.price === 'string') {
                            return { ...v, price: parseInt(v.price.replace(/[^\d]/g, ''), 10) * 100 };
                        }
                        return v;
                    });
                    console.log(`RF: Fetched and Normalized ${this.customOptions.length} custom option variants (via JSON File).`);
                } else {
                    console.warn("RF: Custom Option Data JSON format invalid.");
                }
            } catch (e) {
                console.error("RF: Failed to fetch custom option data", e);
            }
        }

        // initListeners override removed to prevent premature execution via super()

        initFramingLogic() {
            console.log("RF: Framing Logic Active. FormType:", this.formType);
            // Include wood_panel and styrene_panel
            const isFraming = ['aluminum_overmat', 'wood_bookmat', 'aluminum_unified', 'wood_unified', 'wood_panel', 'styrene_panel', 'canvas_panel', 'book_matte'].includes(this.formType);
            console.log("RF: Is Framing Type?", isFraming);

            // [New] Populate Size Options for Unified Forms (Bypass 100 limit)
            if (['aluminum_unified', 'wood_unified'].includes(this.formType)) {
                this.fetchCustomOptionData().then(() => {
                    this.populateUnifiedSizeOptions();
                });
            }

            // 1. UI Visibility Control
            if (isFraming) {
                this.toggleContent(this.elements.colorSection, true);
                this.toggleContent(this.elements.paperSection, true);

                // Wood Panel Specifics
                if (this.formType === 'wood_panel') {
                    this.toggleContent(this.elements.windowSection, false);
                    // Rename Frame Color Label
                    const frameLabel = this.container.querySelector('#rf-frame-color-group .rf-label');
                    if (frameLabel) frameLabel.textContent = '側面テープカラー';
                } else if (this.formType === 'styrene_panel') { // [NEW] Styrene Panel Specifics
                    this.toggleContent(this.elements.windowSection, false);
                    this.toggleContent(this.elements.colorSection, false); // Hide Color
                    // [FIX] Allow Custom Size Mode (User Request)
                    // const sizeSwitcher = this.container.querySelector('.rf-size-switcher');
                    // if (sizeSwitcher) this.toggleContent(sizeSwitcher, false); 
                } else if (this.formType === 'canvas_panel') { // [FIX] Canvas Panel Specifics
                    this.toggleContent(this.elements.windowSection, false);
                    this.toggleContent(this.elements.colorSection, false); // Hide Color (canvas has no frame color)
                }
                else {
                    // [FIX] Don't force show window section for Unified Forms (let setupVisibility handle it based on Processing Type)
                    const isUnified = ['aluminum_unified', 'wood_unified', 'book_matte'].includes(this.formType);
                    if (!isUnified) {
                        this.toggleContent(this.elements.windowSection, true);
                    }
                }

                // Load Paper Data Async
                this.loadPaperData();
            } else if (this.formType === 'print_only') {
                // Default hidden
            }

            // 2. Custom Size Input Listeners (Override/Extend)
            if (this.elements.customShort && this.elements.customLong) {
                // [FIX] デバウンスで用紙サイズ再選択を制御（入力のたびにAPIを叩かない）
                let paperReselectTimer = null;

                [this.elements.customShort, this.elements.customLong].forEach(inp => {
                    if (inp && typeof inp.addEventListener === 'function') {
                        inp.addEventListener('input', () => {
                            this.updateCustomCalculation();
                            this.updateTotalDisplay();

                            // [FIX] 定形外サイズ変更時に用紙タイプ・サイズを再選択
                            clearTimeout(paperReselectTimer);
                            paperReselectTimer = setTimeout(() => {
                                this.updatePaperTypeOptions();
                                this.updatePaperSizeOptions();
                            }, 400);
                        });
                    }
                });
            }

            // Initialize Cache
            this.paperDataCache = {};

            // 3. Mat Window Validation Listeners
            const winShort = this.container.querySelector('#rf-window-short');
            const winLong = this.container.querySelector('#rf-window-long');
            if (winShort && winLong) {
                [winShort, winLong].forEach(inp => {
                    if (inp && typeof inp.addEventListener === 'function') {
                        inp.addEventListener('change', () => this.validateFraming());
                    }
                });
            }

            // 4. Paper/Color Change Listeners
            if (this.elements.paperSelect && typeof this.elements.paperSelect.addEventListener === 'function') {
                this.elements.paperSelect.addEventListener('change', () => this.updateTotalDisplay());
            }
            document.querySelectorAll('input[name="properties[フレームカラー]"]').forEach(r => {
                if (r && typeof r.addEventListener === 'function') {
                    r.addEventListener('change', () => {
                        this.updateTotalDisplay();
                        this.updateVisualState(); // Add this line
                        this.swapGalleryImageForColor(r);
                    });
                }
            });
            document.querySelectorAll('input[name="properties[マットカラー]"]').forEach(r => {
                if (r && typeof r.addEventListener === 'function') {
                    r.addEventListener('change', () => {
                        this.updateTotalDisplay();
                        this.updateVisualState(); // Add this line
                    });
                }
            });

            // [FIX] Explicitly bind Margin Type listeners for Unified Forms
            // The parent initListeners might handle this, but explicit binding here ensures it works for CustomOrderForm logic
            const marginRadios = document.querySelectorAll('input[name="properties[フチ処理]"]');
            if (marginRadios.length > 0) {
                marginRadios.forEach(radio => {
                    radio.addEventListener('change', (e) => {
                        this.handleMarginTypeChange(e);
                        this.updateTotalDisplay();
                        this.updateVisualState();
                    });

                    // Trigger initial state if checked
                    if (radio.checked) {
                        this.handleMarginTypeChange({ target: radio });
                    }
                });
            }
        }

        initPaperLogic() {
            const paperSelect = this.elements.paperSelect;
            if (!paperSelect) return;

            // Populate Main Paper Select (Types)
            // [FIX] Use dynamic method for exclusion logic
            this.updatePaperTypeOptions();

            // Listener for Paper Type Change -> Update Paper Size Options
            if (typeof paperSelect.addEventListener === 'function') {
                paperSelect.addEventListener('change', () => {
                    // [FIX] Async update triggers total update on completion
                    this.updatePaperSizeOptions();
                    // [FIX] Re-evaluate glossy warning when paper type changes
                    this.updateGlossyWarningVisibility();
                    // [ST-28] wood_panel: 光沢紙選択時は ATC を問い合わせ導線に差し替える
                    this.updateWoodPanelGlossyGate();
                    // [NEW] Evaluate layout options based on paper type
                    if (typeof this.updateLayoutOptionsAvailability === 'function') {
                        this.updateLayoutOptionsAvailability();
                    }
                });
            }

            // Listener for Processing Type Change (Overmat/Bookmat toggle)
            document.querySelectorAll('input[name="rf-processing-type"]').forEach(r => {
                if (r && typeof r.addEventListener === 'function') {
                    r.addEventListener('change', () => {
                        this.updatePaperTypeOptions(); // [NEW] Re-filter paper options on processing change
                        this.updatePaperSizeOptions();
                        this.updateWindowSizeVisibility();
                        // [FIX] Re-calculate custom size price when processing type changes
                        // (SKU prefix changes with processing type, affecting custom option variant match)
                        if (this.isCustomMode) {
                            this.updateCustomCalculation();
                        }
                        this.updateTotalDisplay();
                        // [FIX] Re-evaluate glossy warning when processing type changes
                        this.updateGlossyWarningVisibility();
                    });
                }
            });

            // Initial check
            this.updateWindowSizeVisibility();
            // [ST-28] 初期状態のゲート評価(deep-link / ブラウザ自動選択で用紙が入っている場合に対応)
            this.updateWoodPanelGlossyGate();

            // Listener for Paper Size Change
            const paperSizeSelect = this.container.querySelector('#rf-paper-size-select');
            if (paperSizeSelect && typeof paperSizeSelect.addEventListener === 'function') {
                paperSizeSelect.addEventListener('change', () => {
                    console.log("RF: Paper Size changed manually.");
                    this.updateTotalDisplay();
                });
            }

            // [NEW] Paper Size Mode Listeners (ID-based for reliability)
            const paperStandardRadio = this.container.querySelector('#rf-paper-mode-standard');
            const paperCustomRadio = this.container.querySelector('#rf-paper-mode-custom');
            const paperStandardWrapper = this.container.querySelector('#rf-paper-size-standard-wrapper');
            const paperCustomWrapper = this.container.querySelector('#rf-paper-size-custom-wrapper');

            console.log("RF: initPaperLogic Radios:", paperStandardRadio, paperCustomRadio);

            if (paperStandardRadio && paperCustomRadio && paperStandardWrapper && paperCustomWrapper) {
                const togglePaperMode = () => {
                    const isCustom = paperCustomRadio.checked;
                    console.log(`RF: Paper Mode Toggled -> ${isCustom ? 'Custom' : 'Standard'}`);

                    if (isCustom) {
                        paperStandardWrapper.style.display = 'none';
                        paperCustomWrapper.style.display = 'block';
                        this.updatePaperCustomMatch();
                    } else {
                        paperStandardWrapper.style.display = 'block';
                        paperCustomWrapper.style.display = 'none';
                        this.updateTotalDisplay();
                    }
                    this.updateVisualState(); // Add this line
                };

                if (typeof paperStandardRadio.addEventListener === 'function') {
                    paperStandardRadio.addEventListener('change', togglePaperMode);
                    paperStandardRadio.addEventListener('click', togglePaperMode);
                }
                if (typeof paperCustomRadio.addEventListener === 'function') {
                    paperCustomRadio.addEventListener('change', togglePaperMode);
                    paperCustomRadio.addEventListener('click', togglePaperMode);
                }

                // [FIX] Force Click on Label because Input is hidden
                const paperStandardLabel = typeof document.querySelector === 'function' ? document.querySelector('label[for="rf-paper-mode-standard"]') : null;
                const paperCustomLabel = typeof document.querySelector === 'function' ? document.querySelector('label[for="rf-paper-mode-custom"]') : null;

                if (paperStandardLabel && typeof paperStandardLabel.addEventListener === 'function') {
                    paperStandardLabel.addEventListener('click', (e) => {
                        // Force input update
                        setTimeout(() => {
                            paperStandardRadio.checked = true;
                            togglePaperMode();
                        }, 10);
                    });
                }
                if (paperCustomLabel && typeof paperCustomLabel.addEventListener === 'function') {
                    paperCustomLabel.addEventListener('click', (e) => {
                        setTimeout(() => {
                            paperCustomRadio.checked = true;
                            togglePaperMode();
                        }, 10);
                    });
                }

                // Init
                // togglePaperMode(); // Wait, if I run this, it checks 'checked' state. 
                // Default checked is correct in Liquid.
            } else {
                console.warn("RF: Paper Mode Elements missing!");
            }

            // [NEW] Custom Paper Input Listeners
            const paperShortCtx = this.container.querySelector('#rf-paper-custom-short');
            const paperLongCtx = this.container.querySelector('#rf-paper-custom-long');
            if (paperShortCtx && paperLongCtx) {
                const updateMatch = () => this.updatePaperCustomMatch();
                if (typeof paperShortCtx.addEventListener === 'function') {
                    paperShortCtx.addEventListener('input', updateMatch);
                }
                if (typeof paperLongCtx.addEventListener === 'function') {
                    paperLongCtx.addEventListener('input', updateMatch);
                }
            }
        }

        // [New Method] Update Paper Type Options with Handle-based Exclusion Logic + Size Filtering
        updatePaperTypeOptions() {
            const paperSelect = this.elements.paperSelect;
            if (!paperSelect) return;

            // [NEW] Skip paper logic for forms that do not feature paper selection (saves resources and hides irrelevant logs)
            if (['otameshi_print', 'student_discount', 'caption_panel'].includes(this.formType)) {
                return;
            }

            // Use paperHandles (always available)
            const paperHandles = this.config.paperHandles || [];

            // Get exclusion handles for this form type
            const excludedHandles = this.getExcludedPaperHandles();
            console.log("RF: updatePaperTypeOptions -> Excluded Handles:", excludedHandles);

            // [NEW] Get selected size for size-based filtering
            const isCustomMode = document.querySelector('input[name="rf-size-mode"]:checked')?.value === 'custom';
            const selectedSize = isCustomMode ? null : (this.elements.sizeSelect?.value || null);

            // [FIX] Use unified paperMap (this.paperMap populated by loadPaperAvailabilityMap)
            // Fallback to config.paperMap just in case
            const currentMap = this.paperMap || this.config.paperMap || {};
            const isMapLoaded = Object.keys(currentMap).length > 0;

            // [FIX] Race Condition: If map not loaded, show Loading state
            if (!isMapLoaded) {
                console.log("RF: updatePaperTypeOptions -> Map not loaded yet. Waiting...");
                paperSelect.innerHTML = '<option selected disabled>用紙情報を読み込み中...</option>';
                paperSelect.disabled = true;
                return;
            }

            const hasSizeMatch = (handle) => {
                // If map is not loaded yet, fallback to showing options (fail open)
                if (!isMapLoaded) return true;

                const paperVariants = currentMap[handle];
                if (!paperVariants || !Array.isArray(paperVariants)) {
                    // Map is loaded but this handle has no data -> Treat as unavailable
                    return false;
                }

                if (!selectedSize) {
                    // If no size is selected yet (or if in custom mode), 
                    // check if ANY size is available for this paper.
                    // This explicitly ensures that 100% discontinued papers are excluded.
                    return paperVariants.some(v => v.available === true);
                }

                const isFraming = ['aluminum_overmat', 'wood_bookmat', 'aluminum_unified', 'wood_unified', 'wood_panel', 'styrene_panel', 'canvas_panel', 'book_matte'].includes(this.formType);

                if (isFraming) {
                    // [NEW FIX] If it's an Overmat or Bookmat form, DO NOT hide the paper completely based on the frame size.
                    // The user will explicitly select the Paper Size from #rf-paper-size-select instead, where sizes are disabled!
                    const processingType = this.getProcessingType ? this.getProcessingType() : null;
                    const isOvermatOrBookmat = (processingType === 'オーバーマット' || processingType === 'ブックマット' || processingType === 'オーバーマット&スチレンパネル裏貼り' || this.formType === 'book_matte');
                    
                    if (isOvermatOrBookmat) {
                        return paperVariants.some(v => v.available === true);
                    }

                    // 額装などのフォーム：「額縁サイズ (selectedSize)」に対し、入る大きさ以上の「在庫あり」用紙が存在するかチェック
                    let frameW = 0, frameH = 0;
                    const stdDims = this.StandardSizeDict && this.StandardSizeDict[selectedSize];
                    if (stdDims) {
                        frameW = Math.min(stdDims[0], stdDims[1]);
                        frameH = Math.max(stdDims[0], stdDims[1]);
                    } else {
                        const dims = this.getDimensionsFromVariantTitle(selectedSize);
                        if (dims) {
                            frameW = dims[0];
                            frameH = dims[1];
                        }
                    }

                    if (frameW > 0 && frameH > 0) {
                        // 対象フレーム以上の大きさを持つ用紙バリアントのうち、1つでも在庫ありなら表示
                        return paperVariants.some(v => {
                            if (v.available === false) return false; // 在庫切れは除外
                            const pDims = this.getDimensionsFromVariantTitle(v.title || v);
                            if (!pDims) return false;
                            return pDims[0] >= frameW && pDims[1] >= frameH;
                        });
                    } else {
                        // サイズが解析できない場合はフェイルオープン
                        return paperVariants.some(v => v.available === true);
                    }
                } else {
                    // 通常のプリント用紙（printpaper）フォーム：タイトル（例："A4"）の一致をチェック
                    const match = paperVariants.find(v => {
                        const t = typeof v === 'string' ? v : v.title;
                        if (!t) return false;
                        if (t === selectedSize) return true;
                        // Loose matching for standard sizes
                        if (t.startsWith(selectedSize + ' ') || t.startsWith(selectedSize + '(') || t.startsWith(selectedSize + '（')) return true;
                        // Check split matching
                        const selWord = selectedSize.split(" ")[0];
                        const tWord = t.split(" ")[0];
                        if (selWord === tWord && t.includes('(')) return true;
                        return false;
                    });

                    // 一致するサイズが見つかった場合、そのサイズの在庫があれば表示
                    return match ? match.available === true : false;
                }
            };

            // Capture current selection to restore if possible
            const currentSelection = paperSelect.value;

            // [NEW] Glossy Paper Size Limit Check for Unified Forms
            // 額入れのみ + A0以上のサイズの場合は光沢紙を除外
            const processingType = this.getProcessingType ? this.getProcessingType() : null;
            let glossySizeExceeded = false;
            if (['aluminum_unified', 'wood_unified'].includes(this.formType) && processingType === '額入れのみ') {
                // Determine current size dimensions
                let sizeW = 0, sizeH = 0;
                const sizeMode = document.querySelector('input[name="rf-size-mode"]:checked')?.value;
                if (sizeMode === 'custom') {
                    sizeW = parseInt(this.elements.customShort?.value) || 0;
                    sizeH = parseInt(this.elements.customLong?.value) || 0;
                } else if (selectedSize && this.StandardSizeDict) {
                    const dims = this.StandardSizeDict[selectedSize] || this.getDimensionsFromVariantTitle(selectedSize);
                    if (dims) { sizeW = dims[0]; sizeH = dims[1]; }
                }
                const a0Area = 841 * 1189;
                if (sizeW > 0 && sizeH > 0 && (Math.min(sizeW, sizeH) * Math.max(sizeW, sizeH)) >= a0Area) {
                    glossySizeExceeded = true;
                    console.log('RF: Glossy size limit active (A0+, 額入れのみ)');
                }
            }

            // Helper: Check if a paper handle is glossy (via cached tags or keyword fallback)
            const isGlossyHandle = (handle) => {
                if (!this.paperTagsCache) this.paperTagsCache = {};
                // 1. Tag-based check (authoritative)
                if (this.paperTagsCache[handle] && Array.isArray(this.paperTagsCache[handle])) {
                    return this.paperTagsCache[handle].includes('光沢紙');
                }
                // 2. Trigger async fetch if not yet fetched
                if (this.paperTagsCache[handle] === undefined) {
                    this.paperTagsCache[handle] = null;
                    this.fetchPaperTagsForFilter(handle);
                }
                // 3. Keyword fallback while waiting for async
                const paperList = this.config.paperList || [];
                const paperItem = paperList.find(p => p.handle === handle);
                const title = paperItem?.title || handle;
                const glossyKeywords = ['Photo', 'Glossy', 'クリスピア', '光沢', '微光沢', 'シルク', 'Pearl', 'Baryta', 'Metallic', 'ラスター'];
                return glossyKeywords.some(kw => title.includes(kw));
            };

            let availableCount = 0;
            paperSelect.innerHTML = '<option value="" disabled selected>用紙を選択してください</option>';

            paperHandles.forEach(handle => {
                // Check if this handle should be excluded (form type exclusion)
                if (excludedHandles.includes(handle)) {
                    return;
                }

                // [NEW] Check if paper has matching size
                if (!hasSizeMatch(handle)) {
                    console.log(`RF: Paper ${handle} excluded - no matching size for ${selectedSize}`);
                    return;
                }

                // [NEW] Glossy paper exclusion for 額入れのみ + A0 or larger
                if (glossySizeExceeded && isGlossyHandle(handle)) {
                    console.log(`RF: Paper ${handle} excluded - glossy paper not allowed for 額入れのみ at A0+ size`);
                    return;
                }

                const option = document.createElement('option');
                option.value = handle;
                option.dataset.handle = handle; // [FIX] Required for updateLayoutOptionsAvailability
                // Get display name from paperList (array of {handle, title})
                const paperList = this.config.paperList || [];
                const paperItem = paperList.find(p => p.handle === handle);
                option.textContent = paperItem?.title || handle;
                if (handle === currentSelection) option.selected = true;
                paperSelect.appendChild(option);
                availableCount++;
            });

            if (availableCount === 0) {
                paperSelect.innerHTML = '<option value="" disabled>選択可能な用紙がありません</option>';
            }

            this.elements.paperSelect.disabled = availableCount === 0;
            console.log(`RF: updatePaperTypeOptions -> ${availableCount} papers available for size: ${selectedSize}`);
        }

        // [NEW] Get excluded paper handles based on form type
        getExcludedPaperHandles() {
            const formType = this.formType;

            // Canvas papers
            const canvasPapers = [
                'epson-premium-mat-canvas',
                'epson-premium-satin-canvas',
                'claessens-whitematte-canvas'
            ];

            // All papers list (for inverse exclusion)
            const allPapers = this.config.paperHandles || [];

            // 1. Canvas Panel: ONLY canvas papers allowed (exclude everything else)
            if (formType === 'canvas_panel') {
                return allPapers.filter(h => !canvasPapers.includes(h));
            }

            // 2. Wood Panel & Styrene Panel: Detailed Exclusions
            if (formType === 'wood_panel' || formType === 'styrene_panel') {
                // Hahnemuhle All
                const hahnemuhlePapers = allPapers.filter(h => h.includes('hahnemuhle'));

                // Other specific exclusions
                const specificExclusions = [
                    'ilford-mono-silk-warmtone', // モノシルク
                    'ilford-gold-fibre-rag',     // ゴールドファイバーラグ
                    'pictran-kyokushi',          // 局紙
                    'ilford-fineart-smooth-pearl' // FAスムースパール
                ];

                return [...hahnemuhlePapers, ...specificExclusions];
            }

            // 3. Other Forms: No exclusions (Canvas papers allowed)
            return [];
        }

        // [NEW] Evaluate layout options based on selected paper
        updateLayoutOptionsAvailability() {
            const sizeSelect = this.elements.sizeSelect;
            const paperSelect = this.elements.paperSelect;

            // photo_card 用ロジック
            if (this.formType === 'photo_card') {
                if (!sizeSelect || !sizeSelect.value) return;
                const selectedSet = sizeSelect.value.toLowerCase();
                const isEdgePeelPaper = selectedSet.includes('hahnemuhle') ||
                    selectedSet.includes('fineart smooth pearl') ||
                    selectedSet.includes('gold fibre rag');
                this._toggleLayoutOption('borderless', !isEdgePeelPaper);

                // 3mm 余白警告の排他制御:
                //   - edge-peel 用紙 (Hahnemuhle / FASP / Gold Fibre Rag) → edge-peel 警告 のみ表示
                //   - それ以外 → 統合文言「周囲に余白を設けたい場合は3mm以上のフチ...」警告 のみ表示
                const edgePeelWarning = this.container.querySelector('#rf-edge-peel-margin-warning');
                const stdMarginCb = this.container.querySelector('#rf-check-data-margin');
                const stdMarginWarning = stdMarginCb ? stdMarginCb.closest('.rf-context-preview') : null;
                if (edgePeelWarning) {
                    edgePeelWarning.style.display = isEdgePeelPaper ? '' : 'none';
                    if (!isEdgePeelPaper) {
                        const cb = edgePeelWarning.querySelector('#rf-check-edge-peel-margin');
                        if (cb) cb.checked = false;
                    }
                }
                if (stdMarginWarning) {
                    stdMarginWarning.style.display = isEdgePeelPaper ? 'none' : '';
                    if (isEdgePeelPaper && stdMarginCb) stdMarginCb.checked = false;
                }

                // [NEW] Photo Card Logo Consent Logic
                const logoConsentContainer = this.container.querySelector('#rf-photo-card-logo-consent');
                if (logoConsentContainer) {
                    const needsLogoConsent = selectedSet.includes('写真用紙光沢') ||
                                             selectedSet.includes('写真用紙絹目調') ||
                                             selectedSet.includes('プロフォト厚手微光沢') ||
                                             selectedSet.includes('写真用紙クリスピア高光沢');
                    logoConsentContainer.style.display = needsLogoConsent ? 'block' : 'none';
                    // Reset check if hidden
                    if (!needsLogoConsent) {
                        const checkInput = logoConsentContainer.querySelector('#rf-check-photocard-logo');
                        if (checkInput) checkInput.checked = false;
                    }
                }

                return;
            }

            // [FIX] 楮 生成 (awagami-kouzo-kinari) A2サイズ制限
            // A2サイズで「フチなし」「完全データ入稿」を無効化
            // 用紙セレクトが無い/空の場合はURLパスから商品ハンドルを取得（専用ページ対応）
            let paperHandle = paperSelect ? paperSelect.value : '';
            if (!paperHandle) {
                const pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
                if (pathMatch) paperHandle = pathMatch[1];
            }
            const sizeValue = sizeSelect ? sizeSelect.value : '';
            const isKouzoKinari = (paperHandle === 'awagami-kouzo-kinari');
            const isA2 = sizeValue.startsWith('A2') || sizeValue === 'A2';

            if (isKouzoKinari && isA2) {
                this._toggleLayoutOption('borderless', false);
                this._toggleLayoutOption('data', false);
            } else {
                this._toggleLayoutOption('borderless', true);
                this._toggleLayoutOption('data', true);
            }
        }

        // [Helper] レイアウトオプションの表示/非表示切り替え
        _toggleLayoutOption(layoutId, show) {
            const input = this.container.querySelector(`input[name="properties[印刷レイアウト]"][data-layout="${layoutId}"]`);
            if (!input) return;
            const radioCard = input.closest('.rf-radio-card');
            if (!radioCard) return;

            if (show) {
                radioCard.style.display = '';
                input.disabled = false;
            } else {
                radioCard.style.display = 'none';
                input.disabled = true;
                if (input.checked) {
                    input.checked = false;
                    this.handleLayoutChange({ target: input });
                    const fallback = this.container.querySelector('input[name="properties[印刷レイアウト]"][data-layout="border"]');
                    if (fallback) {
                        fallback.checked = true;
                        this.handleLayoutChange({ target: fallback });
                    }
                }
            }
        }

        // [New Helper] Get Exclusion Tag based on Form Type & Processing Type
        getExclusionTag() {
            const formType = this.formType;
            if (formType === 'print_only') return null; // No exclusion for print only

            // Specific Form Type Exclusions
            if (formType === 'wood_panel') return '除外:木製パネル';
            if (formType === 'styrene_panel') return '除外:スチレンパネル';
            if (formType === 'canvas_panel') return '除外:キャンバス張り';

            // Unified Form Types (Check Processing Type)
            const processingType = this.getProcessingType();

            if (formType === 'aluminum_unified') {
                if (processingType === '額入れのみ') return '除外:アルミ額入れ';
                if (processingType === 'オーバーマット') return '除外:アルミオーバーマット';
                if (processingType === 'ブックマット') return '除外:アルミブックマット';
                if (processingType === 'スチレンパネル裏貼り') return '除外:アルミスチレン';
                if (processingType === 'オーバーマット&スチレンパネル裏貼り') return '除外:アルミオーバーマットパネル';
            }

            if (formType === 'wood_unified') {
                if (processingType === '額入れのみ') return '除外:木製額入れ';
                if (processingType === 'オーバーマット') return '除外:木製オーバーマット';
                if (processingType === 'ブックマット') return '除外:木製ブックマット';
                if (processingType === 'スチレンパネル裏貼り') return '除外:木製スチレン';
                if (processingType === 'オーバーマット&スチレンパネル裏貼り') return '除外:木製オーバーマットパネル';
            }

            return null;
        }




        // handlePaperSizeModeChange removed (inlined)

        async updatePaperCustomMatch() {
            const sInput = this.container.querySelector('#rf-paper-custom-short');
            const lInput = this.container.querySelector('#rf-paper-custom-long');
            const matchDisplay = this.container.querySelector('#rf-paper-custom-match');
            const priceDisplay = this.container.querySelector('#rf-paper-custom-price');

            const short = parseInt(sInput.value) || 0;
            const long = parseInt(lInput.value) || 0;

            if (short <= 0 || long <= 0) {
                matchDisplay.textContent = "--";
                priceDisplay.textContent = "";
                this.selectedPaperCustomVariant = null;
                this.updateTotalDisplay();
                return;
            }

            // Calculate fitting
            const handle = this.elements.paperSelect.value;
            if (!handle) return; // Should not happen if visible

            const variants = await this.fetchPaperVariants(handle);
            if (!variants || variants.length === 0) return;

            // Find Smallest Variant that contains (short x long)
            // [FIX] Normalize user input — 短辺/長辺のどちらに入力しても正しく判定
            const userS = Math.min(short, long);
            const userL = Math.max(short, long);

            // [FIX] Use dimension-based comparison instead of area-based
            // Area comparison can be incorrect (e.g. 500x500=250000 > A2 420x594=249480 but fits in one dimension)
            const mainSizeName = this.elements.sizeSelect.value;
            const mainDims = this.getDimensionsFromVariantTitle(mainSizeName);
            const mainS = mainDims ? Math.min(mainDims[0], mainDims[1]) : 0;
            const mainL = mainDims ? Math.max(mainDims[0], mainDims[1]) : 0;

            let bestFit = null;
            let minArea = Infinity;

            variants.forEach(v => {
                let vW = 0, vH = 0;

                // Dictionary lookup
                if (this.STANDARD_SIZES) {
                    for (const [key, val] of Object.entries(this.STANDARD_SIZES)) {
                        if (v.title === key || v.title.startsWith(key + '(') || v.title.startsWith(key + '（') || v.title.startsWith(key + ' /')) {
                            vW = Math.min(val[0], val[1]);
                            vH = Math.max(val[0], val[1]);
                            break;
                        }
                    }
                }

                // Fallback Regex
                if (vW === 0) {
                    const m = v.title.match(/(\d+)\s*[x×]\s*(\d+)/);
                    if (m) { vW = Math.min(parseInt(m[1]), parseInt(m[2])); vH = Math.max(parseInt(m[1]), parseInt(m[2])); }
                }

                if (vW === 0) return; // Skip unknown

                // Check Fit: Paper variant must accommodate user's custom dimensions
                if (vW >= userS && vH >= userL) {
                    const area = vW * vH;

                    // [FIX] Dimension-based exclusion: paper cannot exceed frame in EITHER dimension
                    if (mainS > 0 && mainL > 0) {
                        if (vW > mainS || vH > mainL) return; // Paper exceeds frame dimensions
                    }

                    if (area < minArea) {
                        minArea = area;
                        bestFit = v;
                    }
                }
            });

            if (bestFit) {
                matchDisplay.textContent = bestFit.title;
                const yen = Math.floor(bestFit.price / 100).toLocaleString();
                priceDisplay.textContent = `(+${yen}円)`;
                this.selectedPaperCustomVariant = bestFit;

                // [SYNC] Update the hidden select so Submit/Total logic works
                // Check if option exists (it should, unless filtered by updatePaperSizeOptions logic which differs?)
                // updatePaperSizeOptions uses Standard Main Size vs Standard Paper Size.
                // updatePaperCustomMatch uses Custom Paper Dims vs Standard Main Size.
                // The constraint is the same (Main Area >= Paper Area).
                // So if bestFit passes here, it should be in the select list.

                this.elements.paperSizeSelect = this.container.querySelector('#rf-paper-size-select');
                if (this.elements.paperSizeSelect) {
                    this.elements.paperSizeSelect.value = bestFit.title;
                    // Manually trigger change? No, prevent loop.
                }
            } else {
                matchDisplay.textContent = "サイズオーバー";
                priceDisplay.textContent = "";
                this.selectedPaperCustomVariant = null;
            }

            this.updateTotalDisplay(); // Reflect Price immediately
        }

        // [FIX] Implement missing loadPaperData method
        loadPaperData() {
            console.log("RF: loadPaperData called");
            const paperSelect = this.elements.paperSelect;
            if (paperSelect && paperSelect.value) {
                // If a paper is already selected (e.g. browser autofill), trigger logic
                this.handlePaperTypeChange();
            }
            // If not selected, initPaperLogic (called in constructor) handles the population.
        }

        // [New Helper] Fetch Paper Variants
        async fetchPaperVariants(handle) {
            // [FIX] Reject invalid handles (e.g., loading placeholder text)
            if (!handle || handle.includes('読み込み') || /[\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]/.test(handle)) {
                console.log(`RF: fetchPaperVariants - Invalid handle rejected: ${handle}`);
                return [];
            }

            // [FIX] Use Injected Data (Primary strategy for Local/Preview)
            // Check if data exists AND has variants (price info)
            if (this.config.paperMap && this.config.paperMap[handle]) {
                const data = this.config.paperMap[handle];
                // Only use if it actually has variants array populated
                if (data.variants && Array.isArray(data.variants) && data.variants.length > 0) {
                    console.log(`RF: Using Injected Paper Data for [${handle}]`);
                    return data.variants;
                }
                // If data exists but no variants (only availability map), fall through to JS API
                console.log(`RF: Injected data for [${handle}] has no variants. Falling back to JS API.`);
            }

            // Fallback: Standard .js API (if injection missed it)
            if (this.paperDataCache[handle]) return this.paperDataCache[handle];

            try {
                const encodedHandle = encodeURIComponent(handle);
                const root = window.Shopify.routes.root || '/';
                const basePath = root.endsWith('/') ? root : root + '/';

                // USE .js API (Public, No Auth needed, Returns JSON)
                const url = `${basePath}products/${encodedHandle}.js`;

                console.log(`RF: Fetching Paper Data (JS API) for ${handle}... URL: ${url}`);

                const res = await fetch(url);
                if (!res.ok) {
                    console.error(`RF: Fetch Error ${res.status} ${res.statusText}`);
                    throw new Error('Network response was not ok');
                }

                const productData = await res.json();
                // .js API returns { product: { variants: [...] } } or just product object?
                // Usually returns the product object directly (attributes at top level).
                // Let's verify standard Shopify .js output format.
                // It returns the product object. variants is a property.

                const variants = productData.variants;

                if (variants) {
                    this.paperDataCache[handle] = variants;
                    return variants;
                } else {
                    console.warn('RF: Variants not found in JS API response');
                    return [];
                }
            } catch (e) {
                console.error('RF: Failed to fetch paper data', e);
                return [];
            }
        }



        // [NEW] Window Size Visibility Logic
        updateWindowSizeVisibility() {
            const processingRadio = document.querySelector('input[name="rf-processing-type"]:checked');
            console.log("RF: updateWindowSizeVisibility called. Radio:", processingRadio);

            if (!this.elements || !this.elements.windowSection) {
                console.warn("RF: Missing window section element.");
                return;
            }

            if (!processingRadio) {
                console.warn("RF: Missing processing radio. Hiding window section by default.");
                this.toggleContent(this.elements.windowSection, false);
                return;
            }

            const val = processingRadio.value;
            const targetTypes = [
                'オーバーマット',
                'ブックマット',
                'オーバーマット&スチレンパネル裏貼り'
            ];

            const shouldShow = targetTypes.includes(val);
            console.log(`RF: Processing Type = ${val}, Should Show Window? ${shouldShow}`);

            // Use toggleContent (standard utility) instead of toggleSection
            if (this.elements && this.elements.windowSection) {
                this.toggleContent(this.elements.windowSection, shouldShow);

                // [FIX] Explicitly enable/disable inputs to prevent interaction issues
                if (typeof this.elements.windowSection.querySelectorAll === 'function') {
                    const inputs = this.elements.windowSection.querySelectorAll('input, select');
                    inputs.forEach(inp => {
                        inp.disabled = !shouldShow;
                    });
                }
            }

            // [NEW] Update step numbers dynamically
            this.updateStepNumbers();
        }

        // [NEW] Layout Bleed Warning Visibility
        updateLayoutWarningVisibility() {
            const processingRadio = document.querySelector('input[name="rf-processing-type"]:checked');
            const warningEl = this.container.querySelector('#rf-layout-bleed-warning');
            if (!warningEl) return;

            let shouldShow = false;

            // [FIX] Wood Panel always requires Bleed Warning
            if (this.formType === 'wood_panel' || this.formType === 'styrene_panel') { // [NEW] Styrene Panel
                shouldShow = true;
            } else if (processingRadio) {
                const val = processingRadio.value || '';
                // Show for any processing that involves mounting/wrapping/framing
                // Easiest check: NOT "print_only" (standard print)
                // But here we rely on the radio value labels.
                // Typical labels: "プリントのみ", "アルミフレーム...", "木製...", "パネル..."

                // Logic: Show if Panel or Canvas logic (wrapping often requires bleed)
                // User Feedback: "Unnecessary for Framing (額装)".
                // So we exclude "Overmat", "Bookmat", "Frame" (額).
                // We Include "Panel", "Canvas".

                // Check specifically for Panel/Canvas types that are NOT combined with Mat/Frame
                const isPanelOrCanvas = (val.includes('パネル') || val.includes('キャンバス'));
                const isFraming = (val.includes('マット') || val.includes('額')); // Includes Overmat, Bookmat, Aluminum Frame etc.

                shouldShow = (isPanelOrCanvas && !isFraming);
            }

            // Toggle visibility
            if (shouldShow) {
                if (warningEl && warningEl.style) warningEl.style.display = 'block';
                // Enable input
                const chk = (warningEl && typeof warningEl.querySelector === 'function') ? warningEl.querySelector('input') : null;
                if (chk) chk.disabled = false;
            } else {
                if (warningEl && warningEl.style) warningEl.style.display = 'none';
                // Disable input so it doesn't block submit
                const chk = (warningEl && typeof warningEl.querySelector === 'function') ? warningEl.querySelector('input') : null;
                if (chk) chk.disabled = true;
            }
        }

        async updatePaperSizeOptions() {
            const paperSizeContainer = this.container.querySelector('#rf-paper-size-container');
            const paperSizeSelect = this.container.querySelector('#rf-paper-size-select');
            const paperSelect = this.elements.paperSelect;

            if (!paperSizeContainer || !paperSizeSelect || !paperSelect) return;

            const processingType = this.getProcessingType();
            // [FIX] Show paper size selection for ALL Overmat variations ('オーバーマット', 'ブックマット', 'オーバーマット&スチレンパネル裏貼り')
            // Combined types without overmat like 'スチレンパネル裏貼り', '額入れのみ' should auto-select
            const isOvermatOrBookmat = (processingType === 'オーバーマット' || processingType === 'ブックマット' || processingType === 'オーバーマット&スチレンパネル裏貼り');

            if (isOvermatOrBookmat) {
                // Show Container
                paperSizeContainer.style.display = 'block';

                // [Guard] If Custom Mode is Active, Do NOT rebuild Standard Options.
                // Instead, just re-evaluate the custom match (in case Main Size changed).
                const customRadio = this.container.querySelector('#rf-paper-mode-custom');
                if (customRadio && customRadio.checked) {
                    console.log("RF: Custom mode active. Skipping standard options update.");
                    this.updatePaperCustomMatch();
                    return;
                }

                const handle = paperSelect.value;
                if (!handle) {
                    paperSizeSelect.innerHTML = '<option value="" disabled selected>用紙を選択してください</option>';
                    return;
                }

                // [Refactor] Use Helper
                paperSizeSelect.disabled = true;
                // Show loading if empty? 
                if (paperSizeSelect.options.length <= 1) {
                    paperSizeSelect.innerHTML = '<option value="" disabled selected>読み込み中...</option>';
                }

                const variants = await this.fetchPaperVariants(handle);
                paperSizeSelect.disabled = false;

                // Populate Dropdown
                paperSizeSelect.innerHTML = '<option value="" disabled selected>サイズを選択してください</option>';

                if (variants && variants.length > 0) {
                    // Get Main Size Area for Constraint Check (01 >= 01-3)
                    const mainSizeName = this.elements.sizeSelect ? this.elements.sizeSelect.value : "";
                    // [FIX] Use Dimensions for containment check (A1 vs 600sq issue)
                    const mainDims = this.getDimensionsFromVariantTitle(mainSizeName);

                    const supportedOptions = [];

                    variants.forEach(v => {
                        let isSupported = true;
                        let statusText = "";

                        // 1. Check Availability
                        if (v.available === false) {
                            isSupported = false;
                            statusText = " (在庫切れ)";
                        }

                        // 2. Check Size bounds relation to Frame
                        const paperDims = this.getDimensionsFromVariantTitle(v.title);
                        if (mainDims && paperDims) {
                            const fMin = Math.min(mainDims[0], mainDims[1]);
                            const fMax = Math.max(mainDims[0], mainDims[1]);
                            const pMin = Math.min(paperDims[0], paperDims[1]);
                            const pMax = Math.max(paperDims[0], paperDims[1]);

                            // If Paper is strictly larger than Frame (in either dimension), it's not a valid Mat combination
                            if (pMin > fMin || pMax > fMax) {
                                isSupported = false;
                                statusText = statusText ? statusText + "・非対応サイズ" : " (非対応サイズ)";
                            }
                        } else {
                            const mainArea = this.getSizeArea(mainSizeName);
                            const paperArea = this.getSizeArea(v.title);
                            if (mainArea > 0 && paperArea > 0 && paperArea > mainArea) {
                                isSupported = false;
                                statusText = statusText ? statusText + "・非対応サイズ" : " (非対応サイズ)";
                            }
                        }

                        // [NEW] Hide unsupported options entirely
                        if (isSupported) {
                            const opt = document.createElement('option');
                            opt.value = v.title;
                            opt.dataset.id = v.id;
                            opt.dataset.price = v.price; // Cents

                            const priceYen = Math.floor(v.price / 100);
                            const displayPriceText = v.price > 0 ? ` (+${priceYen.toLocaleString()}円)` : '';
                            
                            opt.textContent = v.title + displayPriceText;
                            supportedOptions.push(opt);
                        }
                    });

                    supportedOptions.forEach(opt => paperSizeSelect.appendChild(opt));

                    // [FIX] Auto-select if requested? Or just let user select.
                    // Trigger update display now that options are ready
                    this.updateTotalDisplay();
                } else {
                    paperSizeSelect.innerHTML = '<option value="" disabled>サイズ情報なし</option>';
                    this.updateTotalDisplay(); // Update anyway to clear potential old price
                }

            } else {
                // Hide Container
                paperSizeContainer.style.display = 'none';

                // [NEW] Logic: If processing type does NOT allow selecting Paper Size (Implied Hidden),
                // We MUST Auto-Select the Paper Size matching the Main Size (01-3 = 01 logic)
                // Unless it is 'frame_only' (No Paper).

                // Exclude styles that do not need paper at all
                const NO_PAPER_STYLES = ['frame_only', 'test_print', 'caption_panel'];

                let autoSelected = false;

                if (processingType && !NO_PAPER_STYLES.includes(processingType) && !processingType.includes('frame_only')) {
                    // [FIX] Use effective size (handles Custom Size logic -> Closest Standard Fit)
                    const mainSize = this.getEffectiveSizeName() || this.elements.sizeSelect.value;
                    const handle = paperSelect.value;



                    if (mainSize && handle) {
                        const variants = await this.fetchPaperVariants(handle);
                        if (variants) {


                            // [FIX] 用紙サイズ自動選択: 常にユーザーの実寸法を基に選択
                            // フレームのサイズ名 (例:"A1") と用紙のサイズ名が異なるため、
                            // タイトル一致ではなく寸法ベースの最小包含マッチングを優先する
                            let match = null;

                            // ユーザーの実寸法を取得
                            let userW = 0, userH = 0;
                            if (this.isCustomMode) {
                                userW = parseInt(this.elements.customShort?.value) || 0;
                                userH = parseInt(this.elements.customLong?.value) || 0;
                            } else {
                                // 定形サイズの場合は sizeSelect の値から寸法を取得
                                const sizeVal = this.elements.sizeSelect?.value;
                                const dims = sizeVal ? this.getDimensionsFromVariantTitle(sizeVal) : null;
                                if (dims) { userW = dims[0]; userH = dims[1]; }
                            }

                            // Strategy 1: 寸法ベースの最小包含マッチング（最も正確）
                            if (userW > 0 && userH > 0) {
                                const inputShort = Math.min(userW, userH);
                                const inputLong = Math.max(userW, userH);
                                let bestMatch = null;
                                let bestArea = Infinity;

                                variants.forEach(v => {
                                    const varTitle = typeof v === 'string' ? v : (v.title || v.option1);
                                    const pDims = this.getDimensionsFromVariantTitle(varTitle);
                                    if (!pDims) return;
                                    const pShort = Math.min(pDims[0], pDims[1]);
                                    const pLong = Math.max(pDims[0], pDims[1]);
                                    // 用紙が入力寸法を包含できるか
                                    if (pShort >= inputShort && pLong >= inputLong) {
                                        const area = pShort * pLong;
                                        if (area < bestArea) {
                                            bestArea = area;
                                            bestMatch = v;
                                        }
                                    }
                                });
                                match = bestMatch;
                                if (match) {

                                }
                            }

                            // Strategy 2: タイトル一致フォールバック（寸法が取得できない場合のみ）
                            if (!match) {

                                match = variants.find(v => v.title === mainSize);
                                if (!match) {
                                    match = variants.find(v => {
                                        const cleanMain = mainSize.split(' ')[0].split('(')[0].split('（')[0];
                                        const cleanVar = (v.title || '').split(' ')[0].split('(')[0].split('（')[0];
                                        return cleanMain === cleanVar;
                                    });
                                }
                            }

                            if (match) {
                                paperSizeSelect.innerHTML = '';
                                const opt = document.createElement('option');
                                opt.value = match.title;
                                opt.dataset.id = match.id;
                                opt.dataset.price = match.price;
                                opt.selected = true;
                                paperSizeSelect.appendChild(opt);
                                paperSizeSelect.value = match.title;

                                autoSelected = true;
                                console.log(`RF: Auto-Selected Paper Size [${match.title}] for processing [${processingType}]`);
                            } else {
                                console.warn(`RF: No paper size match found for mainSize=[${mainSize}], userDims=${userW}x${userH}`);
                            }
                        }
                    }
                }

                if (!autoSelected) {
                    // Default Clear (No Paper)
                    paperSizeSelect.value = "";
                    // Also clear innerHTML to be safe?
                    paperSizeSelect.innerHTML = '<option value="">なし</option>';
                }
            }

            this.updateTotalDisplay(); // Updates price with (or without) new paper variant

            // [NEW] If Mode is Custom, re-run matching because options were rebuilt
            const paperMode = document.querySelector('input[name="rf-paper-size-mode"]:checked')?.value;
            if (paperMode === 'custom') {
                this.updatePaperCustomMatch();
            }

            // [FIX] Dynamic Filtering of Paper Type Dropdown
            // User Request: "Cannot select paper if size doesn't exist"
            this.filterPaperDropdownByEffectiveSize();
        }

        // [New Helper] Filter Paper Type Dropdown based on Effective Size (Dimension Check)
        async filterPaperDropdownByEffectiveSize() {
            const sizeName = this.getEffectiveSizeName();
            if (!sizeName && this.isCustomMode) return; // If custom & invalid

            // If map not loaded yet, try loading it?
            if (!this.paperMap || Object.keys(this.paperMap).length === 0) {
                if (!this.loadingPaperMap) {
                    this.loadPaperAvailabilityMap(); // Trigger load
                }
                return; // Logic will re-run when map loads
            }

            const paperSelect = this.elements.paperSelect;
            if (!paperSelect) return;

            // 1. Determine User Dimensions (Input)
            let userW = 0, userH = 0;
            if (this.isCustomMode) {
                userW = parseInt(this.elements.customShort?.value) || 0;
                userH = parseInt(this.elements.customLong?.value) || 0;
            } else {
                // Standard Size
                const std = this.STANDARD_SIZES[this.elements.sizeSelect?.value];
                if (std) {
                    userW = Math.min(std[0], std[1]);
                    userH = Math.max(std[0], std[1]);
                }
            }

            if (userW <= 0 || userH <= 0) return;

            const originalValue = paperSelect.value;
            let validSelectionNeedsUpdate = false;

            Array.from(paperSelect.options).forEach(opt => {
                const handle = opt.value;
                if (!handle) return;

                const variants = this.paperMap[handle] || [];

                let hasDimensionMatch = false;
                let hasAvailableMatch = false;

                variants.forEach(variant => {
                    const varTitle = typeof variant === 'string' ? variant : variant.title;
                    if (!varTitle) return;

                    const dims = this.getDimensionsFromVariantTitle(varTitle);
                    if (!dims) return;
                    const pShort = dims[0];
                    const pLong = dims[1];
                    const uShort = Math.min(userW, userH);
                    const uLong = Math.max(userW, userH);

                    if (pShort >= uShort && pLong >= uLong) {
                        hasDimensionMatch = true;
                        if (variant.available !== false) {
                            hasAvailableMatch = true;
                        }
                    }
                });

                if (hasAvailableMatch) {
                    opt.disabled = false;
                    opt.textContent = opt.textContent.replace(' (対応サイズなし)', '').replace(' (在庫切れ)', '');
                } else {
                    opt.disabled = true;
                    const baseText = opt.textContent.replace(' (対応サイズなし)', '').replace(' (在庫切れ)', '');
                    
                    if (hasDimensionMatch) {
                        // Dimension fits, but all fitting ones are out of stock
                        opt.textContent = baseText + ' (在庫切れ)';
                    } else {
                        // Dimension does not fit at all
                        opt.textContent = baseText + ' (対応サイズなし)';
                    }

                    // If currently selected is invalid
                    if (handle === originalValue) {
                        validSelectionNeedsUpdate = true;
                    }
                }
            });

            // If current selection is invalid, user must change it.
            if (validSelectionNeedsUpdate) {
                paperSelect.classList.add('rf-input-error');

                // [FIX] Force Deselect and Alert Logic
                // If the user already selected a paper, but it is now invalid due to size change:
                if (originalValue) {
                    console.warn(`RF: Deselecting paper [${originalValue}] because it does not support current size.`);
                    paperSelect.value = ""; // Reset Selection

                    // Optional: Alert the user?
                    // Avoid alert loop if called frequently. 
                    // Using a visual error + console warn is safer, but user might miss it.
                    // Let's us a toast or simple alert ONCE.
                    if (!this.blockAlerts) {
                        // alert("選択された用紙は、現在のサイズに対応していません。\n用紙を選び直してください。"); 
                        // Alert feels too aggressive on every input check. 
                        // Better to just clear and show warning styling?
                    }

                    // Trigger change to update downstream (Paper Size Dropdown etc.)
                    paperSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
            } else {
                paperSelect.classList.remove('rf-input-error');
            }
        }

        async loadPaperAvailabilityMap() {
            if (this.layerPaperMapLoaded) return;
            this.loadingPaperMap = true;

            const url = window.rfConfig.paperMapJsonUrl;
            if (!url) return;

            try {
                const res = await fetch(url);
                if (res.ok) {
                    const data = await res.json();
                    this.paperMap = data;                  // Unified storage
                    this.config.paperMap = data;           // Update config ref
                    this.layerPaperMapLoaded = true;
                    console.log("RF: Static Paper Availability Map Loaded");
                    // Re-run filter (Rebuild options with now-loaded static map)
                    this.updatePaperTypeOptions();

                    // --- [NEW] LIVE INVENTORY OVERRIDE ---
                    // Asynchronously fetch live inventory to patch stale static data
                    this.fetchLiveInventoryOverrides();
                }
            } catch (e) {
                console.error("RF: Failed to load Paper Map", e);
                // If failed, maybe enable dropdown but with basic list?
                // For now, failure leaves it loading or empty.
            } finally {
                this.loadingPaperMap = false;
            }
        }

        // [NEW] Asynchronously fetch live variant availability from Shopify to override the static JSON map.
        async fetchLiveInventoryOverrides() {
            if (!this.paperMap) return;
            const handles = Object.keys(this.paperMap);
            if (handles.length === 0) return;

            console.log(`RF: Fetching Live Inventory Overrides for ${handles.length} papers...`);
            const BATCH_SIZE = 5; // Prevent browser connection limits
            
            for (let i = 0; i < handles.length; i += BATCH_SIZE) {
                const batch = handles.slice(i, i + BATCH_SIZE);
                const promises = batch.map(handle => 
                    fetch(`/products/${handle}.js`)
                        .then(r => r.json())
                        .catch(err => null)
                );
                
                const results = await Promise.all(promises);
                
                let updated = false;
                results.forEach((liveProduct, idx) => {
                    if (liveProduct && liveProduct.variants) {
                        const handle = batch[idx];
                        const staticVariants = this.paperMap[handle];
                        let handleUpdated = false;

                        staticVariants.forEach(staticVar => {
                            const liveVar = liveProduct.variants.find(lv => lv.title === staticVar.title);
                            if (liveVar && staticVar.available !== liveVar.available) {
                                staticVar.available = liveVar.available;
                                handleUpdated = true;
                            }
                        });

                        if (handleUpdated) {
                            updated = true;
                        }
                    }
                });

                // If any paper's availability changed in this batch, re-render the options immediately
                if (updated) {
                    this.updatePaperTypeOptions();
                    if (typeof this.filterPaperDropdownByEffectiveSize === 'function') {
                        this.filterPaperDropdownByEffectiveSize();
                    }
                }
            }
            console.log("RF: Live Inventory Overrides Complete.");
        }

        // [New Helper] Calculate Area for Size Name
        getSizeArea(name) {
            if (!name) return 0;
            let w = 0, h = 0;

            // 1. Dictionary Lookup
            // Try strict match first, then startsWith for "A4 (xxx)"
            if (this.STANDARD_SIZES) {
                for (const [key, val] of Object.entries(this.STANDARD_SIZES)) {
                    if (name === key || name.startsWith(key + '(') || name.startsWith(key + '（') || name.startsWith(key + ' /')) {
                        w = val[0]; h = val[1];
                        break;
                    }
                }
            }

            // 2. Regex Parse
            if (w === 0) {
                const m = name.match(/(\d+)\s*[x×]\s*(\d+)/);
                if (m) { w = parseInt(m[1]); h = parseInt(m[2]); }
            }

            return w * h;
        }

        // [FIX] Missing Helper for Dimension Parsing (Returns [w, h] or null)
        getDimensionsFromVariantTitle(name) {
            if (!name) return null;
            let w = 0, h = 0;

            // 1. Dictionary Lookup
            if (this.STANDARD_SIZES) {
                for (const [key, val] of Object.entries(this.STANDARD_SIZES)) {
                    if (name === key || name.startsWith(key + '(') || name.startsWith(key + '（') || name.startsWith(key + ' /')) {
                        return [val[0], val[1]];
                    }
                }
            }

            // 2. Regex Parse
            const m = name.match(/(\d+)\s*[x×]\s*(\d+)/);
            if (m) {
                w = parseInt(m[1]);
                h = parseInt(m[2]);
                return [Math.min(w, h), Math.max(w, h)]; // Always return [Short, Long]
            }

            return null;
        }

        updateFrameColorOptions() {
            // Guard: For specific form types, NEVER show the color section.
            if (['otameshi_print', 'student_discount', 'caption_panel', 'photo_card'].includes(this.formType)) {
                const colorSection = this.container.querySelector('#rf-section-color');
                if (colorSection) {
                    colorSection.style.display = 'none';
                    colorSection.classList.add('rf-content-hidden');
                }
                return;
            }

            const colorGroup = this.container.querySelector('#rf-frame-color-group');
            if (!colorGroup) return;
            const radioGroup = colorGroup.querySelector('.rf-radio-group');
            if (!radioGroup) return;
            const colorSection = this.container.querySelector('#rf-section-color');

            const size = this.elements.sizeSelect.value;
            const formType = this.formType;

            // Size check: If no size, hide section UNLESS Custom Mode
            if ((!size || size === "") && !this.isCustomMode) {
                if (colorSection) colorSection.classList.add('rf-content-hidden');
                return;
            }

            // ▼▼▼ Hardcoded Color Logic for Unified Products ▼▼▼
            let colorsToRender = [];

            // [FIX] For aluminum_unified, wood_unified, and frame_only, preserve static HTML with images
            // Just show the section and add event listeners, don't rebuild the radio buttons
            if (formType === 'aluminum_unified' || formType === 'wood_unified' || formType === 'frame_only') {
                if (colorSection) {
                    colorSection.classList.remove('rf-content-hidden');
                    colorSection.style.removeProperty('display');
                }
                // Add event listeners to existing static inputs if not already added
                const existingInputs = radioGroup.querySelectorAll('input[type="radio"]');
                existingInputs.forEach(input => {
                    if (!input.dataset.listenerAdded) {
                        input.addEventListener('change', () => {
                            this.updateTotalDisplay();
                            this.updateVisualState();
                        });
                        input.dataset.listenerAdded = 'true';
                    }
                });
                this.updateVisualState();
                return; // Skip rebuilding - preserve static HTML with images
            }

            if (formType === 'styrene_panel' || formType === 'print_only' || formType === 'student_discount') {
                // No Color Options
                colorsToRender = [];
            } else {
                // Legacy / Standard Dynamic Logic
                const safeVariants = this.mainVariants || [];
                const processingType = this.getProcessingType();
                const colorSet = new Set();

                // 定形外サイズ (custom mode) のときは size 制約なしで全 variants からカラー候補を集める。
                // 既存の size 一覧を除外リストとして使うことで、processing type と size を取り除いたものを抽出する。
                let availableVariants;
                let sizeExcludeSet = null;
                if (this.isCustomMode && ['wood_panel', 'aluminum_unified', 'wood_unified'].includes(formType)) {
                    availableVariants = safeVariants;
                    const sizeSelectEl = this.elements && this.elements.sizeSelect;
                    if (sizeSelectEl) {
                        sizeExcludeSet = new Set(
                            Array.from(sizeSelectEl.options || [])
                                .map(o => (o.value || '').trim())
                                .filter(v => v)
                        );
                    }
                } else {
                    availableVariants = safeVariants.filter(v => v.options && v.options.includes(size));
                }

                availableVariants.forEach(v => {
                    // Try to find valid option that is NOT size and NOT processing type
                    v.options.forEach(opt => {
                        if (opt === processingType) return;
                        if (sizeExcludeSet) {
                            if (sizeExcludeSet.has(opt)) return;
                        } else if (opt === size) {
                            return;
                        }
                        colorSet.add(opt);
                    });
                });
                colorsToRender = Array.from(colorSet);
            }

            // [Preservation] Capture currently selected color
            const currentSelection = radioGroup.querySelector('input:checked')?.value;

            // Render
            if (colorsToRender.length > 0) {
                radioGroup.innerHTML = '';

                colorsToRender.forEach(colorName => {
                    const label = document.createElement('label');
                    label.className = 'rf-radio-card rf-radio-mini';

                    const input = document.createElement('input');
                    input.type = 'radio';
                    input.name = (this.formType === 'wood_panel') ? 'properties[側面テープカラー]' : 'properties[フレームカラー]';
                    input.value = colorName;
                    input.className = 'rf-radio-input';

                    // [Preservation] Re-apply selection
                    if (currentSelection && colorName === currentSelection) {
                        input.checked = true;
                    }

                    input.addEventListener('change', () => {
                        this.updateTotalDisplay();
                        this.updateVisualState();
                    });

                    const title = document.createElement('span');
                    title.className = 'rf-radio-title';
                    title.textContent = colorName;

                    label.appendChild(input);
                    label.appendChild(title);
                    radioGroup.appendChild(label);
                });

                if (colorSection) colorSection.classList.remove('rf-content-hidden');
                if (colorSection) colorSection.style.removeProperty('display');

                // [Preservation] Ensure visual state matches checked state immediately
                this.updateVisualState();

            } else {
                // [FIX] Don't hide if Book Matte (needs Mat Color even if no Frame Color)
                if (this.formType !== 'book_matte') {
                    if (colorSection) colorSection.classList.add('rf-content-hidden');
                }
            }
        }

        initMainVariantListeners() {
            if (this.elements && this.elements.sizeSelect && typeof this.elements.sizeSelect.addEventListener === 'function') {
                this.elements.sizeSelect.addEventListener('change', () => {
                    // [FIX] サイズ変更時に用紙リストも再評価（在庫切れ・サイズ適合チェック）
                    this.updatePaperTypeOptions();
                    if (typeof this.filterPaperDropdownByEffectiveSize === 'function') {
                        this.filterPaperDropdownByEffectiveSize();
                    }
                    this.updateTotalDisplay();
                    // [FIX] サイズ変更時にレイアウト制限を再評価（楮 A2制限等）
                    if (typeof this.updateLayoutOptionsAvailability === 'function') {
                        this.updateLayoutOptionsAvailability();
                    }
                });
            }
        }

        toggleSection(el, show) {
            if (!el) return;
            if (show) el.classList.remove('rf-content-hidden');
            else el.classList.add('rf-content-hidden');
        }

        /* -------------------------------------------------------------------------
           Helper Methods
           ------------------------------------------------------------------------- */

        get isCustomMode() {
            return this.container.querySelector('input[name="rf-size-mode"]:checked')?.value === 'custom';
        }

        // [NEW] Dynamic Step Numbering
        updateStepNumbers() {
            // Get all sections
            const sections = Array.from(this.container.querySelectorAll('.rf-section'));

            // Filter visible sections
            const visibleSections = sections.filter(sec => {
                const style = window.getComputedStyle(sec);
                return style.display !== 'none' && !sec.classList.contains('rf-content-hidden');
            });

            // Re-number visible sections sequentially
            let currentStep = 1;
            visibleSections.forEach((sec) => {
                const indicator = sec.querySelector('.rf-step-indicator');
                if (indicator) {
                    // Only overwrite if it's empty, or contains only numbers/hyphens
                    const text = indicator.textContent.trim();
                    if (/^[0-9-]*$/.test(text) || text === '') {
                        indicator.textContent = String(currentStep).padStart(2, '0');
                        currentStep++;
                    }
                }
            });
        }

        // Determine effective standard size name (e.g., "A4")
        getEffectiveSizeName() {
            if (this.isCustomMode) {
                const w = parseInt(this.elements.customShort?.value) || 0;
                const h = parseInt(this.elements.customLong?.value) || 0;
                return this.getSmallestFittingStandardSize(w, h);
            } else {
                return this.elements.sizeSelect ? this.elements.sizeSelect.value : null;
            }
        }

        // [FIX] Dynamic Size Matching from Main Product Variants
        // Instead of iterating abstract Standard Sizes, we iterate ACTUAL available variants.
        getSmallestFittingStandardSize(w, h) {
            const inputShort = Math.min(w, h);
            const inputLong = Math.max(w, h);

            const mainVariants = this.mainVariants || window.rfConfig?.mainVariants || [];

            let bestVariant = null;
            let bestKey = null; // [FIX] Track the matched Clean Key (e.g. "A4")
            let minArea = Infinity;

            mainVariants.forEach(variant => {
                // [FIX] Ignore physically out-of-stock/stopped variants so they cannot serve as upper bounds
                if (variant.available === false) return;

                // 1. Extract Dimensions from Variant Title
                // Strategy: Check if Title starts with any key in STANDARD_SIZE_DICT
                let dims = null;
                let currentKey = null;

                // A. Check Standard Keys (e.g. "A4")
                for (const [key, val] of Object.entries(this.STANDARD_SIZES)) {
                    // strict check or startsWith with explicit separators
                    // [FIX] Added '/', '／', '　' to support various formats e.g. "A3/光沢"
                    const separators = [' ', '　', '/', '／', '(', '（', '[', '［', '-', '_'];

                    if (variant.title === key) {
                        dims = val;
                        currentKey = key;
                        break;
                    }

                    // Check separators
                    const matchSep = separators.some(sep => variant.title.startsWith(key + sep));
                    if (matchSep) {
                        dims = val;
                        currentKey = key;
                        break;
                    }
                }

                // B. If no standard key, check for "Number x Number" pattern (e.g. "200×200")
                if (!dims) {
                    // Matches 200x200, 200×200, 200X200, etc.
                    const match = variant.title.match(/(\d+)\s*[x×X]\s*(\d+)/);
                    if (match) {
                        const d1 = parseInt(match[1]);
                        const d2 = parseInt(match[2]);
                        if (!isNaN(d1) && !isNaN(d2)) {
                            dims = [d1, d2];
                            currentKey = `${d1}x${d2}`; // Fallback name
                        }
                    }
                }

                if (dims) {
                    const stdShort = Math.min(dims[0], dims[1]);
                    const stdLong = Math.max(dims[0], dims[1]);

                    // 2. Check Fit
                    if (inputShort <= stdShort && inputLong <= stdLong) {
                        const area = stdShort * stdLong;
                        // Find smallest area that fits
                        if (area < minArea) {
                            minArea = area;
                            bestVariant = variant;
                            bestKey = currentKey;
                        }
                        // If areas are equal, prefer cheapest? 
                        else if (area === minArea) {
                            if (!bestVariant || variant.price < bestVariant.price) {
                                bestVariant = variant;
                            }
                        }
                    }
                }
            });

            // [FIX] Return the ACTUAL Option1 Value (not the normalized key) so SKU matching works correctly
            const finalSizeName = bestVariant ? bestVariant.options[0] : null;
            console.log(`RF: getSmallestFittingStandardSize -> Best: ${finalSizeName} (Variant: ${bestVariant ? bestVariant.title : 'None'})`);
            return finalSizeName;
        }

        // [New Helper] Extract Dimensions from Variant Title
        getDimensionsFromVariantTitle(title) {
            // [FIX] 型安全ガード: オブジェクトが渡された場合は .title を取得
            if (title && typeof title === 'object' && title.title) {
                title = title.title;
            }
            if (!title || typeof title !== 'string') return null;
            let dims = null;

            // A. Check Standard Keys
            if (this.STANDARD_SIZES) {
                for (const [key, val] of Object.entries(this.STANDARD_SIZES)) {
                    if (title === key || title.startsWith(key + ' ') || title.startsWith(key + '(') || title.startsWith(key + '（')) {
                        dims = val;
                        break;
                    }
                }
            }

            // B. Regex Fallback
            if (!dims) {
                const match = title.match(/(\d+)\s*[x×X]\s*(\d+)/);
                if (match) {
                    const d1 = parseInt(match[1]);
                    const d2 = parseInt(match[2]);
                    if (!isNaN(d1) && !isNaN(d2)) {
                        dims = [d1, d2];
                    }
                }
            }

            // Return structured [short, long]
            if (dims) {
                return [Math.min(dims[0], dims[1]), Math.max(dims[0], dims[1])];
            }
            return null;
        }

        // [COLOR-IMAGE-SWAP] 選択中フレームカラーのカード画像でギャラリーのヒーロー画像を差し替える。
        // 純正の variant->featured_media が無いため直接 <img> を操作。全ガード付き・失敗してもフォームを止めない。
        swapGalleryImageForColor(radio) {
            try {
                if (!radio || !radio.checked) return;
                var card = radio.closest('.rf-radio-card');
                var cardImg = card ? card.querySelector('.rf-card-image img') : null;
                var url = cardImg ? (cardImg.currentSrc || cardImg.src) : null;
                if (!url) return; // テキストのみ色選択(画像なし)は no-op
                var gallery = document.querySelector('product-gallery');
                if (!gallery) return;
                var heroMedia = gallery.querySelector('.product-gallery__media');
                var heroImg = heroMedia ? heroMedia.querySelector('img') : null;
                if (!heroImg) return;
                heroImg.setAttribute('src', url);
                heroImg.removeAttribute('srcset');   // 差し替えた src がレスポンシブで上書きされるのを防ぐ
                heroImg.removeAttribute('data-src');
                if (typeof heroMedia.scrollIntoView === 'function') {
                    heroMedia.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
                }
            } catch (e) {
                console.warn('RF: gallery color swap skipped', e);
            }
        }

        // Resolve Main Product Variant (Item 1)
        // Needs Size + Color (if applicable)
        getMainVariantAndPrice() {
            let price = 0;
            let variantId = null;

            const mainVariants = this.mainVariants || (window.rfConfig && window.rfConfig.mainVariants) || [];
            // [FIX] Ensure we also look at customOptions if loaded (especially for Unified Forms)
            // Filter customOptions by product handle to avoid cross-product variant matching
            let filteredCustomOptions = [];
            if (this.customOptions && this.customOptions.length > 0) {
                const productHandle = this.formType === 'aluminum_unified' ? 'framing-p002' : 'framing-p001';
                filteredCustomOptions = this.customOptions.filter(v => v.product_handle === productHandle);
            }
            const allVariants = filteredCustomOptions.length > 0
                ? [...mainVariants, ...filteredCustomOptions]
                : mainVariants;

            // 1. Check if Custom Size Mode
            // [FIX] For print_only, styrene_panel, book_matte, etc. we MUST find the Main Variant even in Custom Mode
            if (this.isCustomMode && !['print_only', 'styrene_panel', 'canvas_panel', 'book_matte', 'student_discount'].includes(this.formType)) {
                // Already handled by getCustomOptionVariant usually, 
                // but if we are in a mode where Custom Size is just a "variant" (unlikely for Unified), we check.
                // Unified form doesn't really have "Custom Size" in the same way as print_only? 
                // Actually it does. If custom size is active, this method usually returns 0 or base.
                // The actual custom price is added in updateTotalDisplay.
                // So here we might return the "Base Variant" or nothing.

                // For Unified, if custom mode, we might need a base variant?
                // Usually returns empty here if effectively custom.
            } else if (this.formType === 'simple_buy') {
                // 入稿フォーム不要なサンプル/冊子向け。Shopify が選択中の variant をそのまま価格に使う。
                // 複数 variant がある場合は variant_picker での変更を listen して updateTotalDisplay を呼ぶ仕組みは別途追加可能。
                const formEl = this.container.closest('form');
                const idInput = formEl ? formEl.querySelector('input[name="id"]:not([disabled])') : null;
                const selectedId = idInput ? parseInt(idInput.value, 10) : null;
                let chosen = null;
                if (selectedId) chosen = mainVariants.find(v => v.id === selectedId);
                if (!chosen && mainVariants.length > 0) chosen = mainVariants.find(v => v.available) || mainVariants[0];
                if (chosen) {
                    price = chosen.price;
                    variantId = chosen.id;
                }
            } else if (this.formType === 'student_discount') {
                if (mainVariants.length > 0) {
                    price = mainVariants[0].price;
                    variantId = mainVariants[0].id;
                }
            } else {
                // Standard Mode
                const size = this.elements.sizeSelect ? this.elements.sizeSelect.value : null;
                const processingType = this.getProcessingType();

                // [FIX] Get Selected Color
                const colorInput = document.querySelector('input[name="properties[フレームカラー]"]:checked, input[name="properties[カラー]"]:checked, input[name="properties[側面カラー]"]:checked, input[name="properties[テープカラー]"]:checked, input[name="properties[側面テープカラー]"]:checked');
                const color = colorInput ? colorInput.value : null;

                // [Unified Form Lookup]
                if (['aluminum_unified', 'wood_unified'].includes(this.formType)) {

                    const match = allVariants.find(v => {
                        // 1. Size MUST match Option 1 (Index 0)
                        if (v.option1 !== size) return false;

                        // 2. Processing Type Check
                        // If selected, it MUST exist in Option 2 or Option 3 (flexible order)
                        if (processingType) {
                            const opt2 = v.options ? v.options[1] : v.option2;
                            const opt3 = v.options ? v.options[2] : v.option3;
                            const hasType = (opt2 === processingType || opt3 === processingType);
                            if (!hasType) return false;
                        }

                        // 3. Color Check
                        // If selected, it MUST exist in Option 2 or Option 3 (flexible order)
                        if (color) {
                            const opt2 = v.options ? v.options[1] : v.option2;
                            const opt3 = v.options ? v.options[2] : v.option3;
                            const hasColor = (opt2 === color || opt3 === color);
                            if (!hasColor) return false;
                        }

                        return true;
                    });

                    if (match) {
                        // [REFACTOR] Data is normalized, price is always in cents
                        price = match.price;
                        variantId = match.id;
                        // console.log("RF: Match Found (Price):", match.title, "Price (cents):", price);
                    } else {
                        // console.warn("RF: No match found for", size, processingType);
                    }

                } else {
                    // Legacy/Standard
                    const effectiveSize = this.isCustomMode ? this.getEffectiveSizeName() : this.elements.sizeSelect?.value;
                    const colorInputLegacy = document.querySelector('input[name="properties[フレームカラー]"]:checked, input[name="properties[カラー]"]:checked, input[name="properties[側面カラー]"]:checked, input[name="properties[テープカラー]"]:checked, input[name="properties[側面テープカラー]"]:checked');
                    const color = colorInputLegacy?.value;
                    // photo_card variants encode layout as option2 (フチあり / フチなし / 完全データ入稿).
                    // Without this filter the first size-matching variant wins and customers always
                    // get the フチあり SKU regardless of their layout choice.
                    let requiredLayout = null;
                    if (this.formType === 'photo_card') {
                        const layoutRadio = this.container.querySelector('input[name="properties[印刷レイアウト]"]:checked');
                        if (layoutRadio) {
                            const layoutMap = { 'border': 'フチあり', 'borderless': 'フチなし', 'data': '完全データ入稿' };
                            requiredLayout = layoutMap[layoutRadio.dataset.layout] || layoutRadio.value;
                        }
                    }
                    const baseFilter = (v) => {
                        const opts = v.options || [];
                        // [FIX] If Custom Mode OR if form is print_only/styrene_panel, ignore Color in Variant Lookup
                        const ignoreColor = (this.isCustomMode && (this.formType === 'wood_panel' || this.formType === 'styrene_panel' || this.formType.includes('unified')))
                            || this.formType === 'print_only'
                            || this.formType === 'styrene_panel'
                            || this.formType === 'student_discount';
                        if (!opts.includes(effectiveSize)) return false;
                        if (!ignoreColor && color && !opts.includes(color)) return false;
                        return true;
                    };
                    // Try strict match first (size + color + layout). Fall back to size-only
                    // so photo_card products with non-standard layout option strings still show a price.
                    let match = mainVariants.find(v => baseFilter(v) && (!requiredLayout || (v.options || []).includes(requiredLayout)));
                    if (!match && requiredLayout) {
                        match = mainVariants.find(baseFilter);
                        if (match) console.warn('RF: photo_card layout filter no match; falling back to size-only', { effectiveSize, requiredLayout });
                    }

                    if (match) {
                        price = match.price;
                        variantId = match.id;
                    }
                }
            }

            return { id: variantId, price };
        }

        // [New] Populate Size Options for Unified Forms from JSON
        populateUnifiedSizeOptions() {
            if (this._unifiedOptionsPopulated) return; // [FIX] Prevent reset on re-render/update
            if (!this.customOptions || this.customOptions.length === 0) return;

            const sizeSelect = this.elements.sizeSelect;
            if (!sizeSelect) return;

            this._unifiedOptionsPopulated = true; // [FIX] Set flag

            console.log("RF: Populating Unified Size Options...");

            // [FIX] Filter by product handle based on form type
            const productHandle = this.formType === 'aluminum_unified' ? 'framing-p002' : 'framing-p001';
            const filteredVariants = this.customOptions.filter(v => v.product_handle === productHandle);
            console.log(`RF: Filtered to ${filteredVariants.length} variants for ${productHandle}`);

            // 1. Extract Unique Option1 (Size) - Filter out Brackets (where option2 is size range)
            // Standard Variants have Processing Type in Option2 (contains 'のみ', '貼り', 'マット')
            const isStandardVariant = (v) => {
                const opt2 = v.options ? v.options[1] : v.option2;
                return opt2 && (opt2.includes('のみ') || opt2.includes('貼り') || opt2.includes('マット'));
            };

            const sizes = [...new Set(filteredVariants.filter(isStandardVariant).map(v => v.option1))];

            // 2. Populate
            const currentVal = sizeSelect.value;
            sizeSelect.innerHTML = '<option value="" disabled selected>サイズを選択してください(mm)</option>';

            sizes.forEach(size => {
                const opt = document.createElement('option');
                opt.value = size;
                opt.textContent = size;
                if (size === currentVal) opt.selected = true;
                sizeSelect.appendChild(opt);
            });

            // 3. Trigger Update
            if (sizeSelect.value) {
                this.handleSizeSelectChange({ target: sizeSelect });
            }
        }

        updateTotalDisplay() {
            let total = 0;

            // 1. Base Price
            const main = this.getMainVariantAndPrice();
            if (main.id) total += main.price;

            // [NEW] Check Glossy Size Limit (Unified)
            const processingType = this.getProcessingType(); // Need to fetch processing type

            // Determine Size (Short/Long)
            let checkW = 0;
            let checkH = 0;
            if (this.isCustomMode) {
                checkW = parseInt(this.elements.customShort?.value) || 0;
                checkH = parseInt(this.elements.customLong?.value) || 0;
            } else {
                const sizeName = this.elements.sizeSelect.value;
                // Try to resolve dimensions from dict
                if (sizeName && this.StandardSizeDict[sizeName]) {
                    checkW = this.StandardSizeDict[sizeName][0];
                    checkH = this.StandardSizeDict[sizeName][1];
                } else {
                    // Try parsing name? or pass 0 (skip check if unknown)
                    // For now try fallback
                    const dims = this.getDimensionsFromVariantTitle(sizeName);
                    if (dims) {
                        checkW = dims[0];
                        checkH = dims[1];
                    }
                }
            }

            // [FIX] Update Glossy Limit logic for A0 and Above
            const isGlossyLimitExceeded = !this.checkGlossySizeLimit(processingType, checkW, checkH);
            const limitMsg = this.container.querySelector('#rf-custom-size-warning'); // Reuse or create new

            if (isGlossyLimitExceeded) {
                if (limitMsg) {
                    limitMsg.innerHTML = '<p class="rf-note-mini">※光沢紙の「額入れのみ」をご希望かつA0サイズ以上の場合は承ることができません。<br>「スチレンパネル裏貼り」をご検討ください。</p>';
                    limitMsg.style.display = 'block';
                    limitMsg.style.color = '#e74c3c';
                }
                this.setSubmitButtonState(false);
                return; // Stop processing
            } else {
                // If not exceeded, logic continues. 
                // Note: Standard custom size warning logic (max size 1100 etc) might overwrite this 
                // if we don't handle it carefully.
                // But custom size warning is usually for valid input ranges.
            }

            // 2. Custom Option
            if (this.isCustomMode) {
                const s = parseInt(this.elements.customShort?.value) || 0;
                const l = parseInt(this.elements.customLong?.value) || 0;
                const opt = this.getCustomOptionVariant(s, l);
                if (opt) total += opt.price;
            }

            // 3. Paper Price Addition (AJAX Support)
            const paperSizeSelect = this.container.querySelector('#rf-paper-size-select');
            if (paperSizeSelect && paperSizeSelect.value) {
                const selectedOption = paperSizeSelect.options[paperSizeSelect.selectedIndex];
                // data-price is stored as Cents. 
                const paperPrice = parseInt(selectedOption.getAttribute('data-price')) || 0;

                if (paperPrice > 0) {
                    console.log(`RF: Adding Paper Price: ${paperPrice}`);
                    total += paperPrice;
                }
            }

            // 4. Test Print
            const tpCheck = this.container.querySelector('#rf-check-test-print');
            if (tpCheck && tpCheck.checked) {
                const tpData = this.container.querySelector('#rf-test-print-data');
                const tpPrice = parseInt(tpData?.dataset.price) || 0;
                total += tpPrice;
            }

            // Update UI
            this.currentPrice = total;
            // Divide by 100 for display (Assuming Cents)
            let displayPrice = Math.floor(total / 100).toLocaleString();

            const forceUpdate = () => {
                const allPriceElements = this.container.querySelectorAll('#rf-total-price, #rf-total-amount');
                if (allPriceElements.length > 0) {
                    allPriceElements.forEach(el => {
                        if (el.textContent !== displayPrice) el.textContent = displayPrice;
                    });
                }
            };

            forceUpdate();
            setTimeout(forceUpdate, 200);

            // [NEW] Sync Visual State
            this.updateVisualState();

            // [NEW] Update Glossy Warning checkbox visibility
            this.updateGlossyWarningVisibility();
        }

        /* -------------------------------------------------------------------------
           Core Logic Overrides
           ------------------------------------------------------------------------- */
        // [NEW] Helper: Check if Glossy Paper Size Limit is Exceeded
        checkGlossySizeLimit(processingType, w, h) {
            if (processingType !== '額入れのみ') return true; // Limit only applies to "額入れのみ"

            const isGlossy = this.isGlossyPaperSelected();
            if (!isGlossy) return true;

            // A0 Size dimensions
            const a0Short = 841;
            const a0Long = 1189;

            const short = Math.min(w, h);
            const long = Math.max(w, h);

            // If dimensions are A0 or larger (by Area), it's NOT allowed.
            const a0Area = a0Short * a0Long;
            if ((short * long) >= a0Area) {
                return false; // Limit exceeded
            }

            return true; // Within limits or dimensions not yet fully defined
        }

        // [NEW] Helper: Check if Glossy Paper is Selected
        isGlossyPaperSelected() {
            const paperSelect = this.container.querySelector('#rf-paper-select');
            if (!paperSelect || !paperSelect.value) {
                // Fallback or initialization state
                return false;
            }

            const handle = paperSelect.value;

            if (!this.paperTagsCache) this.paperTagsCache = {};

            // 1. If we already fetched the real Shopify tags for this paper, use them!
            if (this.paperTagsCache[handle] && Array.isArray(this.paperTagsCache[handle])) {
                return this.paperTagsCache[handle].includes('光沢紙');
            }

            // 2. If it's undefined, we need to fetch it async. We mark it as pending (null)
            // so we don't trigger multiple fetches for the same paper handle.
            if (this.paperTagsCache[handle] === undefined) {
                this.paperTagsCache[handle] = null; // Pending
                this.fetchPaperTagsAndRefresh(handle);
            }

            // 3. Fallback: While waiting for the AJAX request (which takes ~100ms), 
            // string match the title so the UI feels perfectly instantaneous.
            // Try to get the raw paper handle or title
            const selectedText = paperSelect.options[paperSelect.selectedIndex]?.textContent || '';
            const glossyKeywords = ['Photo', 'Glossy', 'クリスピア', '光沢', '微光沢', 'シルク', 'Pearl', 'Baryta', 'Metallic', 'ラスター'];

            return glossyKeywords.some(keyword => selectedText.includes(keyword));
        }

        // [NEW] Async helper to silently load Shopify Product Tags and correct UI
        async fetchPaperTagsAndRefresh(handle) {
            try {
                const root = window.Shopify?.routes?.root || '/';
                const basePath = root.endsWith('/') ? root : root + '/';
                const url = `${basePath}products/${encodeURIComponent(handle)}.js`;

                const res = await fetch(url);
                if (!res.ok) throw new Error('Network response was not ok');

                const productData = await res.json();

                // Cache the actual tags from Shopify Admin
                this.paperTagsCache[handle] = productData.tags || [];

                console.log(`RF: Fetched Tags for ${handle}:`, this.paperTagsCache[handle]);

                // Re-trigger the glossy warning visibility check now that we have truth
                this.updateGlossyWarningVisibility();
                // [ST-28] 実タグ確定後に wood_panel の ATC/問い合わせ ゲートを再評価
                this.updateWoodPanelGlossyGate();
            } catch (e) {
                console.error('RF: Failed to fetch tags for', handle, e);
                // On failure, keep it null so fallback continues to operate
            }
        }

        // [NEW] Async helper to fetch tags for paper filtering (glossy exclusion in dropdown)
        async fetchPaperTagsForFilter(handle) {
            try {
                const root = window.Shopify?.routes?.root || '/';
                const basePath = root.endsWith('/') ? root : root + '/';
                const url = `${basePath}products/${encodeURIComponent(handle)}.js`;

                const res = await fetch(url);
                if (!res.ok) throw new Error('Network response was not ok');

                const productData = await res.json();
                this.paperTagsCache[handle] = productData.tags || [];
                console.log(`RF: Fetched Tags (filter) for ${handle}:`, this.paperTagsCache[handle]);

                // Re-build paper list now that we have accurate tag data
                this.updatePaperTypeOptions();
            } catch (e) {
                console.error('RF: Failed to fetch tags (filter) for', handle, e);
            }
        }

        // [NEW] Helper: Helper to update Glossy Warning Checkbox visibility
        updateGlossyWarningVisibility() {
            // Only applies to unified forms
            if (!['aluminum_unified', 'wood_unified'].includes(this.formType)) return;

            const warningSection = this.container.querySelector('#rf-section-glossy-warning');
            if (!warningSection) return;

            const processingType = this.getProcessingType();
            const isGlossy = this.isGlossyPaperSelected();

            // Show warning if: (Frame Only AND Glossy) OR (Overmat AND Glossy)
            const needsWarning = isGlossy && (processingType === '額入れのみ' || processingType === 'オーバーマット');

            if (needsWarning) {
                warningSection.style.removeProperty('display');
                warningSection.classList.remove('rf-content-hidden');
            } else {
                warningSection.style.display = 'none';
                warningSection.classList.add('rf-content-hidden');
                // Uncheck the agreement if hidden
                const agreeCheck = this.container.querySelector('#rf-check-glossy-agree');
                if (agreeCheck) agreeCheck.checked = false;
            }

            // [NEW] Update step numbers dynamically
            this.updateStepNumbers();
        }

        // [ST-28] wood_panel: 光沢紙が選択されたら
        //   (1) 「カートに追加」を隠す(問い合わせボタンへの切り替えは buy-buttons 側の共通ボタンで維持)
        //   (2) 用紙選択セクション内に注記＋お問い合わせ導線(mailto)を表示
        // 光沢紙判定は用紙商品の '光沢紙' タグ準拠(isGlossyPaperSelected / paperTagsCache)。
        updateWoodPanelGlossyGate() {
            if (this.formType !== 'wood_panel') return;

            const atcWrapper = document.querySelector('#rf-add-btn-wrapper');       // カートに追加
            const atcInquiry = document.querySelector('#rf-glossy-atc-inquiry');    // 買い物ボタン側 mailto ボタン
            const inquiry = document.querySelector('#rf-glossy-inquiry');           // 用紙選択セクション内 導線
            const paperLink = inquiry ? inquiry.querySelector('#rf-glossy-inquiry-link') : null;
            // 既存の共通「お問い合わせはこちら」(チャット起動)ボタン。mailto に揃えるため光沢時は隠す。
            const chattyBtn = document.querySelector('.gpo-clone-atc-button');
            const chattyWrap = chattyBtn ? (chattyBtn.closest('div') || chattyBtn) : null;

            // クリック直前に最新のフォーム状態で本文を作り直す(用紙選択後に余白・フチ処理等を入力しても反映)。
            [atcInquiry, paperLink].forEach(link => RF_CONTACT.bind(link, () => this.buildGlossyInquiryText()));

            // rf-dashboard の「お問い合わせ ›」は lead-time.js が描画し、再描画で innerHTML ごと
            // 差し替わるため直接バインドでは失われる。委譲で拾う。件名を「納期相談」ではなく
            // 光沢紙の件として出したいので、lead-time 側の汎用導線(data-rf-inquiry)には委ねない。
            if (!this._glossyConsultDelegated) {
                this._glossyConsultDelegated = true;
                document.addEventListener('click', (e) => {
                    const a = (e.target && e.target.closest) ? e.target.closest('a[data-rf-glossy-consult]') : null;
                    if (!a) return;
                    e.preventDefault();
                    let base = '';
                    try { base = this.buildGlossyInquiryText(); } catch (err) { base = ''; }
                    const go = (text) => { RF_CONTACT.stash(text); window.location.href = RF_CONTACT.URL; };
                    RF_CONTACT.cartSection().then(c => go(base + c)).catch(() => go(base));
                }, true);
            }

            const paperSelect = this.container.querySelector('#rf-paper-select');
            // 用紙未選択の間はゲートしない(通常の ATC を表示)。
            const hasPaper = paperSelect && paperSelect.value;
            const isGlossy = hasPaper && this.isGlossyPaperSelected();

            if (isGlossy) {
                if (atcWrapper) atcWrapper.style.display = 'none';
                if (atcInquiry) { atcInquiry.href = RF_CONTACT.URL; atcInquiry.style.display = ''; }
                if (chattyWrap) chattyWrap.style.display = 'none';
                if (inquiry) {
                    if (paperLink) paperLink.href = RF_CONTACT.URL;
                    inquiry.style.display = 'block';
                }
            } else {
                // 元のインライン style は display:contents。元値へ戻す。
                if (atcWrapper) atcWrapper.style.display = 'contents';
                if (atcInquiry) atcInquiry.style.display = 'none';
                if (chattyWrap) chattyWrap.style.display = '';
                if (inquiry) inquiry.style.display = 'none';
            }

            // [ST-28拡張] rf-dashboard の納期(営業日)表示も光沢時は「お問い合わせください」に切替える。
            // 用紙選択は lead-time-calculator の再計算トリガー(size/qty/種類等)に含まれないため、
            // data-glossy-consult をセット/解除した上で handleProductPageUpdate() で明示的に再描画させる。
            const lt = document.querySelector('lead-time-calculator');
            if (lt) {
                if (isGlossy) lt.dataset.glossyConsult = '1';
                else delete lt.dataset.glossyConsult;
                if (typeof lt.handleProductPageUpdate === 'function') lt.handleProductPageUpdate();
            }
        }

        // [ST-28 / 2026-07-17] 光沢紙×木製パネル加工のお問い合わせ本文を、選択中の用紙・サイズ入りで組み立てる。
        // 送信先は mailto ではなく既存のお問い合わせフォーム(/pages/contact)。件名は本文冒頭に畳み込まれる。
        buildGlossyInquiryText() {
            const prodName = (window.rfConfig && window.rfConfig.productTitle) || '木製パネル加工';
            const lines = [
                '木製パネル加工にて、光沢紙での作成を希望します。',
                '下記の内容でお見積り・ご相談をお願いいたします。',
                '',
                '【ご入力いただいた内容】',
                `商品名: ${prodName}`,
                '加工: 木製パネル加工'
            ];
            // 入力済みの項目(用紙・サイズ・用紙サイズ・フチ処理・余白・レイアウト・各種了承 等)を漏れなく追記。
            this.collectEnteredProperties().forEach(l => lines.push(l));
            lines.push('', '※ご希望の枚数・納期などがございましたらご記入ください。');
            return RF_CONTACT.compose('木製パネル加工（光沢紙）のお問い合わせ', lines);
        }

        // [ST-28] フォームの properties[...] から「入力済み」の項目を収集する(お問い合わせメール本文用)。
        //   - select        : 選択中オプションの表示名(用紙種類は handle でなくタイトルになる)
        //   - radio/checkbox : チェック済みのみ、その value
        //   - text/number/textarea/hidden : 空でない value
        //   - 除外           : 内部用(_始まり) / 無効(disabled) / 未解錠・非表示セクション内(未入力扱い)
        collectEnteredProperties() {
            const form = (this.container && this.container.closest('form')) || document.querySelector('form[action*="/cart/add"]');
            if (!form) return [];
            const out = [];
            const seen = new Set();
            form.querySelectorAll('[name^="properties["]').forEach(el => {
                const name = el.getAttribute('name') || '';
                const m = name.match(/^properties\[(.+)\]$/);
                if (!m) return;
                const label = m[1];
                if (label.charAt(0) === '_') return;
                if (el.disabled) return;
                if (seen.has(label)) return;
                // 適用外(logic 非表示 = rf-content-hidden)の項目のみ除外。
                // 段階ロック(rf-locked-progressive)は「まだ到達していないだけ」なので、値があれば入力済みとして拾う。
                if (el.closest('.rf-content-hidden')) return;
                let val = '';
                const type = (el.type || '').toLowerCase();
                if (el.tagName === 'SELECT') {
                    if (!el.value) return;
                    const opt = el.options[el.selectedIndex];
                    val = ((opt && opt.textContent) || el.value).trim();
                } else if (type === 'radio' || type === 'checkbox') {
                    if (!el.checked) return;
                    val = (el.value || '').trim();
                } else {
                    val = (el.value || '').trim();
                }
                if (!val) return;
                seen.add(label);
                out.push(`${label}: ${val}`);
            });
            return out;
        }

        // ▼▼▼ 追加: 現在選択されている加工タイプを取得する関数 ▼▼▼
        getProcessingType() {
            if (['aluminum_unified', 'wood_unified'].includes(this.formType)) {
                const el = document.querySelector('input[name="rf-processing-type"]:checked');
                return el ? el.value : null;
            }
            // [FIX] Wood Panel has fixed processing type
            if (this.formType === 'wood_panel') {
                return '木製パネル加工';
            }
            if (this.config.formType === 'styrene_panel') return 'スチレンパネル加工'; // [NEW] Styrene
            if (this.config.formType === 'canvas_panel') return 'キャンバスパネル加工'; // [NEW] Canvas Panel
            if (this.config.formType === 'book_matte') return 'ブックマット'; // [NEW] Book Matte
            // Default (Print Only or unknown)
            return null;
        }


        updateCustomCalculation() {
            if (!this.isCustomMode) return;

            const s = parseInt(this.elements.customShort?.value) || 0;
            const l = parseInt(this.elements.customLong?.value) || 0;
            const display = this.container.querySelector('#rf-custom-display');
            const priceDisplay = this.container.querySelector('#rf-price-display'); // For single item price

            if (s > 0 && l > 0) {
                let displayText = `【定形外】${s} x ${l} mm`;

                // [FIX] Price Display Logic Split
                // [FIX] Price Display Logic Split
                // User Request: invalid A3 price -> validation error.
                // For print_only and styrene_panel (and book_matte, caption_panel), we find the "Fitted Standard Size".
                if (this.formType === 'print_only' || this.formType === 'styrene_panel' || this.formType === 'book_matte' || this.formType === 'caption_panel') {
                    const bestSize = this.getSmallestFittingStandardSize(s, l); // Returns Option Value e.g. "A4 (210x297)"

                    // Find Price from Main Variants
                    const mainVariants = this.mainVariants || window.rfConfig?.mainVariants || [];
                    // Match logic varies slightly:
                    // print_only: v.title === bestSize || v.options.includes(bestSize)
                    // styrene_panel: v.options[0] === bestSize

                    let matchedVariant = null;
                    if (this.formType === 'styrene_panel' || this.formType === 'book_matte' || this.formType === 'caption_panel') {
                        matchedVariant = mainVariants.find(v => v.options[0] === bestSize);
                    } else {
                        matchedVariant = mainVariants.find(v => v.title === bestSize || v.options.includes(bestSize));
                    }

                    if (matchedVariant) {
                        // Found Fitted Standard Size
                        display.textContent = `最適サイズ: ${matchedVariant.title}`;
                        priceDisplay.innerHTML = this.formatCurrency(matchedVariant.price);
                        this.currentBasePrice = matchedVariant.price;
                    } else {
                        // No Custom Option Match
                        this.currentBasePrice = 0;
                        display.textContent = "対応サイズなし";

                        // [2026-07-17] お問い合わせフォーム(/pages/contact)へ誘導し本文を自動入力。
                        const prodName = (this.productData && this.productData.title) || window.rfConfig?.productTitle || "商品名不明";
                        const inquiryText = RF_CONTACT.compose("サイズ見積もり依頼", [
                            '【ご入力いただいた内容】',
                            `商品名: ${prodName}`,
                            `希望サイズ: ${s}mm x ${l}mm`
                        ]);
                        priceDisplay.innerHTML = `<a href="${RF_CONTACT.URL}" style="text-decoration:underline; color:#000;">お問合せください</a>`;
                        RF_CONTACT.bind(priceDisplay.querySelector('a'), () => inquiryText);
                    }
                    return;
                } else {
                    // Framing: Calculate Item 4 Price (Custom Frame Cost)
                    const opt = this.getCustomOptionVariant(s, l);
                    if (opt) {
                        // [FIX] Shopify API returns price as string in YEN, not cents.
                        // Convert to cents for formatCurrency if string.
                        const priceInCents = typeof opt.price === 'string'
                            ? parseInt(opt.price, 10) * 100
                            : opt.price;
                        priceDisplay.textContent = this.formatCurrency(priceInCents);
                        this.currentBasePrice = priceInCents; // [FIX] Store in cents for consistency
                    } else {
                        this.currentBasePrice = 0;
                        display.textContent = "対応サイズなし";

                        // [2026-07-17] お問い合わせフォーム(/pages/contact)へ誘導し本文を自動入力。
                        const prodName = (this.productData && this.productData.title) || window.rfConfig?.productTitle || "商品名不明";
                        const processName = this.getProcessingType() || this.formType;
                        const inquiryText = RF_CONTACT.compose("サイズ見積もり依頼", [
                            '【ご入力いただいた内容】',
                            `商品名: ${prodName}`,
                            `加工: ${processName}`,
                            `希望サイズ: ${s}mm x ${l}mm`
                        ]);
                        priceDisplay.innerHTML = `<a href="${RF_CONTACT.URL}" style="text-decoration:underline; color:#000;">お問合せください</a>`;
                        RF_CONTACT.bind(priceDisplay.querySelector('a'), () => inquiryText);
                        return;
                    }
                }
                display.textContent = displayText;
            }
        }

        // [NEW] Helper to determine SKU Prefix based on Form Type / Processing
        getSkuPrefix() {
            let material = '';
            if (this.formType.includes('aluminum')) material = 'AL';
            else if (this.formType.includes('wood')) material = 'WD';
            else if (this.formType.includes('styrene')) material = 'ST'; // [NEW] Styrene

            if (!material) return null;

            const procName = this.getProcessingType() || '';
            let code = '';

            // Legacy / Specific overrides
            if (this.formType === 'aluminum_overmat') return 'AL-OM-PNL';
            if (this.formType === 'wood_bookmat') return 'WD-BKMT';
            // [NEW] Wood Panel
            if (this.formType === 'wood_panel') return 'WD-PNL';
            if (this.config.formType === 'styrene_panel') return 'ST-PNL'; // [NEW] Styrene
            if (this.config.formType === 'book_matte') return 'BKMT'; // [NEW] Book Matte

            // Unified Logic Mapping (Exact Match via snippets/processing_type_section.liquid)
            if (procName === '額入れのみ') {
                code = 'FRAME';
            } else if (procName === 'オーバーマット') {
                code = 'OM-ONLY';
            } else if (procName === 'ブックマット') {
                code = 'BKMT';
            } else if (procName === 'スチレンパネル裏貼り') {
                code = 'STY-BCK';
            } else if (procName === 'オーバーマット&スチレンパネル裏貼り') {
                code = 'OM-STY-';
            }

            if (material && code) return `${material}-${code}`;
            return null;
        }

        getCustomOptionVariant(w, h) {
            if (!this.customOptions.length) return null;

            // [FIX] Filter by SKU Prefix
            const skuPrefix = this.getSkuPrefix();
            console.log(`RF: getCustomOptionVariant Prefix: [${skuPrefix}], Dims: ${w}x${h}`);
            if (!skuPrefix) {
                console.log("RF: No SKU Prefix resolved. Skipping Custom Option Search.");
                return null;
            }

            const short = Math.min(w, h);
            const long = Math.max(w, h);

            const parseLimit = (str) => {
                // Handle "〜100mm" or just "100" or raw number
                if (typeof str === 'number') return str;
                if (!str) return Infinity;
                return parseInt(str.toString().replace(/[^\d]/g, ''), 10);
            };

            let logCount = 0;

            // Filter valid variants (Option dimensions >= Input dimensions AND SKU Match)
            const valid = this.customOptions.filter(v => {
                // [FIX] Ignore physically out-of-stock/stopped variants
                if (v.available === false) return false;

                // SKU Check
                if (v.sku && !v.sku.startsWith(skuPrefix)) return false;

                // Check missing SKU
                if (!v.sku) return false;

                // User Structure: Option1="仕様"(Type), Option2="短辺"(Short), Option3="長辺"(Long)
                const limit1 = parseLimit(v.option2); // Short limit (was option1)
                const limit2 = parseLimit(v.option3); // Long limit (was option2)

                const isMatch = short <= limit1 && long <= limit2;

                if (logCount < 5) {
                    console.log(`RF: Check [${v.sku}] Limits: ${limit1} / ${limit2} vs Input: ${short} / ${long} -> Match? ${isMatch}`);
                    logCount++;
                }
                return isMatch;
            });

            console.log(`RF: Valid Custom Variants Found: ${valid.length}`);
            if (valid.length > 0) {
                console.log(`RF: Best Match:`, valid[0]);
            }

            valid.sort((a, b) => a.price - b.price);
            return valid[0] || null;
        }

        setupVisibility() {
            // [REFACTOR] Strategy Pattern via Config
            const isUnified = ['wood_unified', 'aluminum_unified', 'styrene_panel', 'canvas_panel', 'book_matte'].includes(this.formType);
            
            const formConfig = {
                // Unified Frame products
                'wood_unified': { hidden: [] },
                'aluminum_unified': { hidden: [] },
                // Panel products
                'styrene_panel': { hidden: ['rf-section-color', 'rf-section-processing-type'] },
                'canvas_panel': { hidden: ['rf-section-color', 'rf-section-window', 'rf-section-processing-type'], hideSizeSwitcher: true },
                'wood_panel': { hidden: ['rf-section-processing-type'] },
                'book_matte': { hidden: ['rf-section-processing-type'] }, 
                // Print / Special workflows
                'print_only': { hidden: ['rf-section-color', 'rf-section-window', 'rf-section-margin', 'rf-section-borderless', 'rf-section-data', 'rf-section-processing-type'] },
                'photo_card': { hidden: ['rf-section-color', 'rf-section-window', 'rf-section-margin', 'rf-section-borderless', 'rf-section-data', 'rf-section-processing-type'], hideSizeSwitcher: true },
                'vps2026': { hidden: ['rf-section-color', 'rf-section-window', 'rf-section-margin', 'rf-section-borderless', 'rf-section-data', 'rf-section-processing-type'] },
                'otameshi_print': { hidden: ['rf-section-layout', 'rf-section-color', 'rf-section-window', 'rf-section-paper', 'rf-section-test-print', 'rf-section-margin', 'rf-section-borderless', 'rf-section-data'], hideSizeSwitcher: true },
                'student_discount': { hidden: ['rf-section-size', 'rf-section-layout', 'rf-section-color', 'rf-section-window', 'rf-section-paper', 'rf-section-test-print', 'rf-section-margin', 'rf-section-borderless', 'rf-section-data', 'rf-section-processing-type'] },
                'caption_panel': { hidden: ['rf-section-color', 'rf-section-window', 'rf-section-layout', 'rf-section-test-print', 'rf-section-margin', 'rf-section-borderless', 'rf-section-data'] },
                'frame_only': { hidden: ['rf-section-layout', 'rf-section-paper', 'rf-section-window', 'rf-section-processing-type', 'rf-section-test-print', 'rf-section-upload', 'rf-section-margin', 'rf-section-borderless', 'rf-section-data'], hideSizeSwitcher: true }
            };

            const config = formConfig[this.formType] || { hidden: [] };

            // 1. Process config-based hidden sections
            if (config.hidden && config.hidden.length > 0) {
                config.hidden.forEach(id => {
                    const el = this.container.querySelector('#' + id);
                    if (el) {
                        el.style.display = 'none';
                        el.classList.add('rf-content-hidden');
                        el.querySelectorAll('input, select, textarea').forEach(inp => inp.disabled = true);
                    }
                });
            }

            // Size Switcher hiding
            if (config.hideSizeSwitcher) {
                const sizeSwitcher = this.container.querySelector('.rf-size-switcher');
                if (sizeSwitcher) sizeSwitcher.style.display = 'none';
            }

            // 2. Dynamic Processing Type Logic (Mat windows, Overlap notices)
            let procType = '額入れのみ';
            if (isUnified) {
                procType = this.getProcessingType();

                // Explicitly unhide Processing Type ONLY for Unified standard forms that shouldn't hide it
                const procSection = this.container.querySelector('#rf-section-processing-type');
                if (procSection && !config.hidden.includes('rf-section-processing-type')) {
                    procSection.style.removeProperty('display');
                    procSection.classList.remove('rf-content-hidden');
                    procSection.querySelectorAll('input, select, textarea').forEach(inp => inp.disabled = false);
                }

                // Explicitly show Frame Color for unified (unless hidden by config)
                const colorSection = this.container.querySelector('#rf-section-color');
                if (colorSection && !config.hidden.includes('rf-section-color')) {
                    colorSection.style.display = '';
                    colorSection.classList.remove('rf-content-hidden');
                    colorSection.querySelectorAll('input, select, textarea').forEach(inp => inp.disabled = false);
                }

                // Ensure paper section is visible if NOT in hidden config
                if (!config.hidden.includes('rf-section-paper')) {
                    const paperSection = this.container.querySelector('#rf-section-paper');
                    if (paperSection) paperSection.classList.remove('rf-content-hidden');
                }
            } else {
                if (this.formType && this.formType.includes('overmat')) procType = 'オーバーマット';
                else if (this.formType && this.formType.includes('bookmat')) procType = 'ブックマット';
            }

            const needsMat = (procType === 'オーバーマット' || procType === 'ブックマット' || procType === 'オーバーマット&スチレンパネル裏貼り');

            const matGroup = this.container.querySelector('#rf-mat-color-group');
            if (matGroup) {
                matGroup.style.display = needsMat ? 'block' : 'none';
                if (typeof matGroup.querySelectorAll === 'function') {
                    matGroup.querySelectorAll('input').forEach(el => el.disabled = !needsMat);
                }
            }

            // Only dynamic window section toggle if it's NOT disabled by config
            const windowSection = this.container.querySelector('#rf-section-window');
            if (windowSection && !config.hidden.includes('rf-section-window')) {
                if (needsMat) {
                    if (windowSection.classList) windowSection.classList.remove('rf-content-hidden');
                    windowSection.style.removeProperty('display');
                    if (typeof windowSection.querySelectorAll === 'function') windowSection.querySelectorAll('input').forEach(el => el.disabled = false);
                } else {
                    if (windowSection.classList) windowSection.classList.add('rf-content-hidden');
                    windowSection.style.display = 'none';
                    if (typeof windowSection.querySelectorAll === 'function') windowSection.querySelectorAll('input').forEach(el => el.disabled = true);
                }
            }

            const overlapNotice = this.container.querySelector('#rf-window-overlap-notice');
            if (overlapNotice) {
                if (procType === 'オーバーマット&スチレンパネル裏貼り' || !needsMat) {
                    overlapNotice.style.display = 'none';
                    const overlapCheck = this.container.querySelector('#rf-check-window-overlap');
                    if (overlapCheck) overlapCheck.checked = false;
                } else if (needsMat) {
                    overlapNotice.style.display = 'block';
                }
            }

            // 3. Custom UI Overrides (Special Form Requirements)
            if (this.formType === 'caption_panel') {
                const captionOptRadio = this.container.querySelector('input[name="properties[出力データ作成オプション]"]:checked');
                const isCreateMode = (captionOptRadio && captionOptRadio.value === '希望する');
                const captionDetails = this.container.querySelector('#rf-caption-details');
                if (captionDetails) this.handleSimpleToggle(isCreateMode, captionDetails);
            }

            if (this.formType === 'otameshi_print' || this.formType === 'photo_card') {
                const sizeTitle = this.container.querySelector('#rf-section-size .rf-section-title');
                if (sizeTitle) {
                    if (this.formType === 'otameshi_print') {
                        const parentHeader = sizeTitle.closest('.rf-header-left');
                        if (parentHeader) {
                            parentHeader.style.display = 'flex';
                            parentHeader.style.alignItems = 'baseline';
                            parentHeader.style.width = '100%';
                        }
                        sizeTitle.style.margin = '0';
                        sizeTitle.style.display = 'flex';
                        sizeTitle.style.width = '100%';
                        sizeTitle.style.justifyContent = 'space-between';
                        sizeTitle.style.alignItems = 'baseline';
                        sizeTitle.innerHTML = '<span>セット選択 <span class="rf-required">*</span></span><a id="rf-testprint-25off-link" href="#testprint-premium-sets" style="color:#999; font-size:0.75rem; font-weight:normal; text-decoration:underline; white-space:nowrap;">初回25%OFF適用へ</a>';
                    } else {
                        sizeTitle.innerHTML = 'セット選択 <span class="rf-required">*</span>';
                    }
                }
            }

            if (this.formType === 'student_discount') {
                const uploadTitle = this.container.querySelector('#rf-section-upload .rf-section-title');
                if (uploadTitle) uploadTitle.innerHTML = '学生証データアップロード(両面) <span class="rf-required">*</span>';
                const totalArea = this.container.querySelector('#rf-total-area') || this.container.closest('form')?.querySelector('.rf-total-area');
                if (totalArea) totalArea.style.display = 'none';
                this.container.querySelectorAll('.rf-qty-selector').forEach(el => el.style.display = 'none');
                const remarksGroup = this.container.querySelector('#rf-file-remarks-group');
                if (remarksGroup) remarksGroup.style.display = 'none';
            }

            if (this.formType === 'frame_only') {
                const sizeTitle = this.container.querySelector('#rf-section-size .rf-section-title');
                if (sizeTitle) sizeTitle.innerHTML = '額内寸法 <span class="rf-required">*</span>';
            }

            this.enforceBookMatConstraints(); // Constrain Custom Size for Book Mat
            this.updateGlossyWarningVisibility(); // Update Glossy Warning (Unified)
            this.updateMatMarginWarning(); // Update Mat Margin Warning
            this.updateStepNumbers(); // Update step numbers dynamically
            
            // [FIX] Recalculate progressive disclosure after config has hidden sections.
            // Without this, the previously first section gets the unlock, and when it's hidden by config,
            // the actual available section remains locked indefinitely.
            if (typeof this.updateVisualState === 'function') {
                this.updateVisualState();
            }
        } // [FIX] Added missing closing brace for setupVisibility()

        // [NEW] Enforce Book Mat Constraints (No Custom Size)
        enforceBookMatConstraints() {
            const isUnified = ['aluminum_unified', 'wood_unified'].includes(this.formType);
            const isBookMatForm = (this.formType === 'book_matte');

            if (!isUnified && !isBookMatForm) return;

            let isBookMatProcessing = false;
            if (isUnified) {
                const procType = this.getProcessingType();
                // [MODIFIED] Include Over Mat types as well
                if (procType) {
                    isBookMatProcessing = (procType.includes('ブックマット') || procType.includes('オーバーマット'));
                }
            } else {
                // Standalone Book Mat form implies Book Mat processing
                isBookMatProcessing = true;
            }

            // 1. Main Size Switcher (Frame/Outer Size)
            const customRadio = this.container.querySelector('#rf-mode-custom');
            const customContainer = document.querySelector('label[for="rf-mode-custom"]')?.closest('.rf-radio-pill')
                || document.querySelector('label[for="rf-mode-custom"]');
            const standardRadio = this.container.querySelector('#rf-mode-standard');

            // 2. Paper Size Switcher (Inside 01-3 Paper Selection)
            const paperCustomRadio = this.container.querySelector('#rf-paper-mode-custom');
            // The Paper Size Switcher container is usually .rf-size-switcher-sm
            const paperCustomContainer = this.container.querySelector('.rf-size-switcher-sm') ||
                document.querySelector('label[for="rf-paper-mode-custom"]')?.closest('.rf-size-switcher');
            const paperStandardRadio = this.container.querySelector('#rf-paper-mode-standard');


            const disableSwitcher = (radio, container, stdRadio, hide = false) => {
                if (!radio) return;
                radio.disabled = true;

                if (container) {
                    if (hide) {
                        container.style.display = 'none';
                    } else {
                        container.classList.add('rf-disabled');
                        container.style.opacity = '0.5';
                        container.style.pointerEvents = 'none';
                        container.title = "選択された加工タイプは規格サイズのみ対応しています";
                    }
                }

                if (radio.checked && stdRadio) {
                    stdRadio.checked = true;
                    stdRadio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            };

            const enableSwitcher = (radio, container) => {
                if (!radio) return;
                radio.disabled = false;

                if (container) {
                    container.style.display = ''; // Restore display
                    container.classList.remove('rf-disabled');
                    container.style.opacity = '1';
                    container.style.pointerEvents = 'auto';
                    container.removeAttribute('title');
                }
            };

            if (isBookMatProcessing) {
                // Main Switcher: Disable (Visually dimmed) — 納品サイズは規格サイズのみ
                disableSwitcher(customRadio, customContainer, standardRadio);

                // [FIX] Paper Switcher: ENABLE — 用紙サイズの定形外は利用可能にする
                // 以前は完全非表示(hide=true)にしていたが、用紙サイズの定形外は
                // オーバーマット/ブックマット時にも選択できるべき
                enableSwitcher(paperCustomRadio, paperCustomContainer);

            } else {
                enableSwitcher(customRadio, customContainer);
                enableSwitcher(paperCustomRadio, paperCustomContainer);
            }
        }

        // [NEW] Update Mat Margin Warning Visibility
        updateMatMarginWarning() {
            // Warning Logic
            const warning = this.container.querySelector('#rf-mat-margin-warning');
            if (!warning) return;

            // Check Form Type (Unified or Book Mat)
            const isUnified = ['aluminum_unified', 'wood_unified'].includes(this.formType);
            const isBookMatForm = (this.formType === 'book_matte');

            // Show only if (Unified AND Processing Type is appropriate) OR (Book Mat form)
            // Rule: "Book Mat" or "Over Mat"
            if (isUnified) {
                const procType = this.getProcessingType();
                // Mat processing types usually contain 'マット' but let's be specific based on request
                // "Unified form 01-2 processing: Book Mat or Over Mat"
                const needsMarginWarning = (
                    procType === 'ブックマット' ||
                    procType === 'オーバーマット'
                    // [FIX] Removed 'オーバーマット&スチレンパネル裏貼り' per request
                );

                if (needsMarginWarning) {
                    warning.style.display = 'block';
                } else {
                    warning.style.display = 'none';
                }
            } else if (isBookMatForm) {
                // Book Mat form always needs warning (assuming it is always Book Mat processing)
                warning.style.display = 'block';
            } else {
                warning.style.display = 'none';
            }
        }

        getProperties() {
            const props = {};
            // [FIX] Search entire document to capture all property inputs (some are outside this.container)
            const inputs = document.querySelectorAll('[name^="properties"]');
            inputs.forEach(el => {
                // [FIX] Skip inputs inside hidden sections (irrelevant for current product type)
                const hiddenParent = el.closest('.rf-content-hidden, [style*="display: none"], [style*="display:none"]');
                if (hiddenParent) return;

                // [DEBUG] Trace every input
                const isSkipped = el.disabled || (['radio', 'checkbox'].includes(el.type) && !el.checked);
                // console.log(`RF PROPS DEBUG: Found [${el.name}] Val:[${el.value}] Disabled:[${el.disabled}] Checked:[${el.checked}] -> Skip? ${isSkipped}`);

                if (isSkipped) return;

                // Skip "test print" - handled separately
                // But if it is explicitly named, we capture it.

                const keyMatch = el.name.match(/properties\[(.*?)\]/);
                if (keyMatch) {
                    // [FIX] For Wood Panel, 'フレームカラー' is '側面テープカラー'
                    let key = keyMatch[1];
                    if (this.formType === 'wood_panel' && key === 'フレームカラー') {
                        key = '側面テープカラー';
                    } else if (this.formType === 'styrene_panel' && key === 'フレームカラー') { // [NEW] Styrene Panel
                        key = '側面テープ';
                    }
                    let val = el.value;
                    // [2026-06-22] 用紙種類セレクトは option.value=handle(英語)のため、カート/注文には
                    // 日本語表示名(option テキスト)を入れる(価格/在庫ロジックは value=handle を継続使用)。
                    if (key === '用紙種類' && el.tagName === 'SELECT' && el.selectedIndex >= 0 && el.options[el.selectedIndex]) {
                        val = (el.options[el.selectedIndex].textContent || val).trim();
                    }
                    props[key] = val;
                }
            });

            // [FIX] Explicitly Capture Processing Type ONLY if Unified (Visible)
            if (['aluminum_unified', 'wood_unified'].includes(this.formType)) {
                const processing = document.querySelector('input[name="rf-processing-type"]:checked');
                if (processing) {
                    props['加工種別'] = processing.value;
                }
            }
            // [FIX] Wood Panel explicit Processing Type
            else if (this.formType === 'wood_panel') {
                props['加工種別'] = '木製パネル加工';
            }
            else if (this.formType === 'styrene_panel') { // [NEW] Styrene Panel
                props['加工種別'] = 'スチレンパネル加工';
            }
            else if (this.formType === 'canvas_panel') {
                props['加工種別'] = 'キャンバスパネル加工';
            }

            return props;
        }

        updateTotalDisplay() {
            let oneItemTotal = 0; // Unit Price of Main Item Set (Frame + Paper + CustomOption)

            // --- 1. 計算ロジック (既存のコードを維持) ---

            // 1. Item 1 (Main/Frame or Print Variant)
            const main = this.getMainVariantAndPrice();
            // [FIX] Double Entry Prevention: If Custom Mode, ignore Main Item Price (Standard)
            // We rely on Item 4 (Custom Option) for FRAMES (unified, wood_panel, etc.)
            // But for 'print_only' and 'styrene_panel', we rely on Main Item (Standard Variant) snapped price.
            const skipMainPriceForCustom = (this.isCustomMode && ['aluminum_unified', 'wood_unified', 'wood_panel', 'aluminum_overmat', 'wood_bookmat'].includes(this.formType));

            if (main.id && !skipMainPriceForCustom) {
                // [FIX] Ensure price is number to prevent string concatenation
                const mainPrice = parseInt(main.price, 10) || 0;
                oneItemTotal += mainPrice;
                this.currentBasePrice = mainPrice; // [FIX] Sync Validation Price
            }

            // 2. Item 2 (Paper) - Framingモードのみ
            // 2. Item 2 (Paper) - Framingモードのみ
            // [Verified Update] Include Unified types AND wood_panel
            if (['aluminum_overmat', 'wood_bookmat', 'wood_unified', 'aluminum_unified', 'wood_panel', 'styrene_panel', 'canvas_panel', 'book_matte'].includes(this.formType)) { // [NEW] Canvas Panel
                const paperSizeSelect = this.container.querySelector('#rf-paper-size-select');
                if (paperSizeSelect && paperSizeSelect.value) {
                    const selectedOption = paperSizeSelect.options[paperSizeSelect.selectedIndex];
                    const paperPriceRaw = selectedOption.getAttribute('data-price');
                    const paperPrice = parseInt(paperPriceRaw) || 0;

                    if (paperPrice > 0) {
                        console.log(`RF: Adding Paper Price: ${paperPrice}`);
                        oneItemTotal += paperPrice;
                    } else {
                        console.log(`RF: Paper selected but price is 0 or invalid (Raw: ${paperPriceRaw})`);
                    }
                }
            }

            // 3. Item 4 (Custom Option) - Only NOT print_only
            // print_only Custom Price is covered by Item 1 (fitting variant) logic above
            // 3. Item 4 (Custom Option)
            // [Verified Update] Enable for ALL types including print_only in Custom Mode
            // [FIX] Only add custom option price if it's NOT print_only (print_only uses Item 1 variant logic)
            // Removed styrene_panel, wood_panel, etc. from exclusion to allow Item 4 calculation
            if (this.isCustomMode && this.formType !== 'print_only' && this.formType !== 'book_matte' && this.formType !== 'canvas_panel') {
                const s = parseInt(this.elements.customShort?.value) || 0;
                const l = parseInt(this.elements.customLong?.value) || 0;
                const opt = this.getCustomOptionVariant(s, l);
                if (opt) {
                    // [FIX] opt.price from JSON is YEN string, convert to cents
                    const optPriceInCents = typeof opt.price === 'string'
                        ? parseInt(opt.price, 10) * 100
                        : opt.price;
                    oneItemTotal += optPriceInCents;
                    this.currentBasePrice = optPriceInCents; // [FIX] Sync Validation Price
                }
            }

            // [FIX] Quantity Logic (Main Item)
            const qtyInput = this.container.querySelector('#rf-qty-input');
            const qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;

            let total = oneItemTotal * qty;


            // 4. Test Print (Separate Quantity)
            const tpCheck = this.container.querySelector('#rf-check-test-print');
            let testPrintTotal = 0;
            if (tpCheck && tpCheck.checked) {
                const tpData = this.container.querySelector('#rf-test-print-data');
                const tpPrice = parseInt(tpData?.dataset.price) || 0;

                // Fetch Test Print Quantity
                const tpQtyInput = this.container.querySelector('.rf-tp-qty-input') || this.container.querySelector('#rf-test-print-qty');
                // Note: HTML class/id might vary, assuming logic. If specific ID exists, use it.
                // Previous code used `this.elements.testPrintQtyInput`.
                const tpQty = parseInt(this.elements.testPrintQtyInput?.value) || 1;

                if (tpPrice > 0) {
                    testPrintTotal = tpPrice * tpQty;
                    total += testPrintTotal; // Add to Grand Total
                }
            }

            // --- 2. 表示更新ロジック ---

            this.currentPrice = total; // 内部値を更新

            // ▼▼▼ Shopify仕様対応: 100で割ってカンマ区切りにする ▼▼▼
            // 例: 217000 → 2,170
            let displayPrice = Math.floor(total / 100).toLocaleString();

            console.log(`RF: Updating Display. Raw: ${total}, Display: ${displayPrice}`);

            // HTML要素を確実に探す (rf-total-price を優先)
            const priceElement = (this.container && typeof this.container.querySelector === 'function' ? this.container.querySelector('#rf-total-price') : null)
                || this.container.querySelector('#rf-total-price')
                || this.container.querySelector('#rf-total-amount');
            // [2026-07-17] 金額未確定(サイズ未選択等で total=0)の間は「¥0」を出さない。
            // liquid 側の初期値は '--' なのに、JS が到着直後に 0 で上書きしていた。
            // 検索流入が主体の用紙ページで「¥0」は無料/故障に読め、価格表示としても不適切。
            // 0 は「無料」ではなく「まだ決まっていない」なので、その通りに描く。
            // 「¥」は CSS の ::before で常時付くため、未確定時は data 属性で記号ごと消す(¥-- を避ける)。
            const priceUndetermined = !(total > 0);
            const displayText = priceUndetermined ? '--' : displayPrice;
            if (priceElement) {
                priceElement.textContent = displayText;
                if (priceUndetermined) priceElement.dataset.rfUndetermined = '1';
                else delete priceElement.dataset.rfUndetermined;
            } else if (this.elements.totalPrice) {
                this.elements.totalPrice.innerText = displayText;
            }

            // [FIX] Delivery Date Sync
            // Do NOT overwrite #rf-delivery-date here. LeadTimeCalculator handles it.
            // Trigger generic update event instead.
            document.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true }));
        }

        validateBleed() {
            // Validate Layout Bleed Confirmation (if visible)
            const bleedWarning = this.container.querySelector('#rf-layout-bleed-warning');
            if (bleedWarning && bleedWarning.style.display !== 'none') {
                const bleedCheck = this.container.querySelector('#rf-check-bleed-agree');
                if (bleedCheck && !bleedCheck.checked) {
                    alert("「周囲に塗り足しが必要です」に同意してください。");
                    bleedWarning.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return false;
                }
            }
            return true;
        }

        validateFraming() {
            // Validation only needed if Window Section is Visible AND relevant processing type is selected
            // [FIX] Strict check on processing type to avoid "hidden but validating" bugs
            const processingRadio = this.container.querySelector('input[name="rf-processing-type"]:checked');
            const matTypes = [
                'オーバーマット',
                'ブックマット',
                'オーバーマット&スチレンパネル裏貼り'
            ];

            // If no processing selected (unlikely) or type is NOT a Mat type, skip validation.
            // [FIX] Explicitly skip wood_panel (it has no Mat)
            if (this.formType === 'wood_panel' || this.formType === 'styrene_panel' || !processingRadio || !matTypes.includes(processingRadio.value)) {
                // Ensure error message is hidden if we skip
                const msg = this.container.querySelector('#rf-window-error');
                if (msg) msg.style.display = 'none';
                return true;
            }

            const windowSection = this.container.querySelector('#rf-section-window');
            // Secondary safety check: if hidden by some other means, also skip
            if (!windowSection || windowSection.classList.contains('rf-content-hidden') || windowSection.style.display === 'none') {
                return true;
            }

            const msg = this.container.querySelector('#rf-window-error');
            if (msg) msg.style.display = 'none';

            // 1. Validate Checkbox (only if the notice is visible)
            const overlapNotice = this.container.querySelector('#rf-window-overlap-notice');
            const overlapCheck = this.container.querySelector('#rf-check-window-overlap');
            const isOverlapNoticeVisible = overlapNotice && overlapNotice.style.display !== 'none';
            if (isOverlapNoticeVisible && overlapCheck && !overlapCheck.checked) {
                if (msg) {
                    msg.textContent = "「マット窓寸法に各5mm作品を被せる」ことに同意してください。";
                    msg.style.display = 'block';
                }
                return false;
            }

            // 2. Validate Mat Color
            const matColor = document.querySelector('input[name="properties[マットカラー]"]:checked');
            if (!matColor) {
                if (msg) {
                    msg.textContent = "マットカラーを選択してください。";
                    msg.style.display = 'block';
                }
                return false;
            }


            // 3. Validate Dimensions
            const wShort = parseInt(this.container.querySelector('#rf-window-short')?.value) || 0;
            const wLong = parseInt(this.container.querySelector('#rf-window-long')?.value) || 0;

            if (wShort <= 0 || wLong <= 0) {
                // Let standard "Required" check catch this, or force it here:
                if (msg) {
                    msg.textContent = "窓寸法を入力してください。";
                    msg.style.display = 'block';
                }
                return false;
            }

            // Rule: Window must be smaller than Frame Size
            const sizeName = this.getEffectiveSizeName();
            const frameDims = this.STANDARD_SIZES[sizeName];

            if (frameDims) {
                const fShort = Math.min(frameDims[0], frameDims[1]);
                const fLong = Math.max(frameDims[0], frameDims[1]);
                const inputShort = Math.min(wShort, wLong);
                const inputLong = Math.max(wShort, wLong);

                if (inputShort >= fShort || inputLong >= fLong) {
                    if (msg) {
                        msg.textContent = `窓寸法は、選択したサイズ(${sizeName}: ${fShort}x${fLong}mm)より小さい必要があります。`;
                        msg.style.display = 'block';
                    }
                    return false;
                }
            }
            return true;
        }

        async handleRobustSubmit(e) {
            console.log("🚀 RF: handleRobustSubmit STARTED");
            if (e) { e.preventDefault(); e.stopPropagation(); }

            if (!super.validateForm()) {
                console.log("RF: super.validateForm() failed");
                return;
            }

            // [ST-28] wood_panel + 光沢紙 は直接カート投入不可。問い合わせ導線へ誘導(ATC 非表示の防御ネット)。
            if (this.formType === 'wood_panel' && this.isGlossyPaperSelected()) {
                console.log("RF: wood_panel glossy paper blocked from cart (ST-28)");
                this.updateWoodPanelGlossyGate();
                alert('光沢紙での木製パネル加工は、お問い合わせにて承っております。\nお手数ですが「お問い合わせはこちら」よりご連絡ください。');
                return;
            }

            // [FIX] Upload Integrity Check
            const fileItems = this.elements.fileList ? this.elements.fileList.querySelectorAll('.rf-file-item') : [];
            if (fileItems.length > 0) {
                // 1. Check for visual errors
                if (this.elements.fileList.querySelector('.rf-file-item.rf-error')) {
                    alert("アップロードに失敗したファイルが含まれています。削除してから再度お試しください。");
                    return;
                }

                // 2. Check for in-progress uploads
                const incomplete = this.elements.fileList.querySelectorAll('.rf-file-item:not(.rf-upload-complete)');
                if (incomplete.length > 0) {
                    alert("ファイルのアップロード中です。完了までお待ちください。");
                    return;
                }

                // 3. Deep Data Validation (Count valid URLs)
                const validFiles = this.uploadedFiles.filter(f => f.downloadUrl && f.downloadUrl.trim() !== '');

                // Note: mismatch could happen if removeFile logic is buggy or race condition
                if (fileItems.length !== validFiles.length) {
                    console.error("RF Validation Error: DOM items vs Valid URLs mismatch", fileItems.length, validFiles.length);
                    alert("ファイルのアップロード情報が正しく連携されていません。\n恐れ入りますが、一度ファイルを削除して再度アップロードしてください。");
                    return;
                }
            }

            // [FIX 2026-07-28] base の handleRobustSubmit にある2つの処理が、この override で丸ごと欠落していた。
            // 用紙商品(print_only 等)は全てこの override を通るため、本番で次の2つが起きていた:
            //   ① 「ファイル毎の枚数の合計 > 注文総数」のままカートに入る
            //      → 3枚指定しているのに注文総数(旧値)の2で購入される = 過少請求/現場との不一致
            //   ② アップロード後に枚数を変えても #rf-file-names(properties[入稿ファイル名]) が古いまま
            //      → 注文明細の「A.jpg (1枚)」が実際の指定と食い違う
            // base と同じ順序・同じ関数で復元する(ロジックを再実装しない = 二重定義で再びズレるため)。
            this.updateHiddenFilesInput();
            const qtyValid = await this.validateTotalQuantity(null, true);
            if (!qtyValid) {
                console.log("RF: Quantity Validation Failed/Cancelled");
                this.isSubmitting = false;
                return;
            }

            // [FIX] Separate Bleed Validation from Window Validation to prevent wrong error messages
            if (!this.validateBleed()) {
                console.log("RF: validateBleed() failed");
                return;
            }

            if (!this.validateFraming()) {
                console.log("RF: validateFraming() failed");
                alert("窓寸法の設定を確認してください。");
                return;
            }

            this.isSubmitting = true;
            // [FIX] Crasher: Use bound element or safe query
            const btn = this.elements.addToCartBtn || this.container.closest('form')?.querySelector('.rf-btn-add-to-cart') || document.querySelector('button[name="add"]');
            if (btn) { btn.textContent = '処理中...'; btn.disabled = true; }

            const items = [];
            const bundleId = `bundle_${Date.now()}`;

            // [FIX] Robust Quantity Retrieval
            // If Custom Form is hidden, we must grab the Standard Input (name="quantity")
            let qty = 1;
            if (this.elements.qtyInput && this.elements.qtyInput.offsetParent !== null) {
                qty = parseInt(this.elements.qtyInput.value) || 1;
            } else {
                // Fallback: Find input in the same form
                const parentForm = btn ? btn.closest('form') : document.querySelector('form[action$="/cart/add"]');
                if (parentForm) {
                    const stdInput = parentForm.querySelector('input[name="quantity"]');
                    if (stdInput) qty = parseInt(stdInput.value) || 1;
                }
            }

            // --- Calculate Item 1 (Main) ---
            const main = this.getMainVariantAndPrice();

            // [FIX] For frames (unified/custom), we skip Main Item in Custom Mode (using Item 4 instead).
            // BUT for 'print_only' and 'styrene_panel', we MUST include Main Item (the fitted standard variant).
            const skipMainCheck = (this.isCustomMode && !['print_only', 'styrene_panel', 'canvas_panel', 'book_matte'].includes(this.formType) && ['aluminum_unified', 'wood_unified', 'wood_panel', 'aluminum_overmat', 'wood_bookmat'].includes(this.formType));

            if (!main.id && !skipMainCheck) {
                const isNoColorForm = ['print_only', 'styrene_panel', 'student_discount'].includes(this.formType);
                const alertMsg = isNoColorForm
                    ? "商品バリアントが見つかりません。サイズを確認してください。"
                    : "商品(フレーム)のバリアントが見つかりません。サイズ/カラーを確認してください。";
                alert(alertMsg);
                this.unlockSubmit(btn);
                return;
            }

            const properties = this.getProperties(); // From super
            console.log("RF DEBUG: Collected Properties:", properties); // [DEBUG]

            // [NEW] 定形外サイズの明示 (注文管理画面 + ユーザー表示用)
            if (this.isCustomMode) {
                const cShort = this.container.querySelector('#rf-size-short')?.value;
                const cLong = this.container.querySelector('#rf-size-long')?.value;
                if (cShort && cLong) {
                    properties['サイズ種別'] = '定形外';
                    properties['印刷サイズ'] = `定形外サイズ: ${cShort}x${cLong}mm`;
                }
            } else if (this.formType !== 'simple_buy') {
                // 定形サイズの場合もサイズ種別を明示 (simple_buy サンプルには付与しない)
                properties['サイズ種別'] = '定形';
            }

            // [NEW] Firebase URL分割: カンマ区切りURLを個別プロパティに変換
            // Shopify管理画面で各URLを個別にクリックできるようにする
            let fileCounter = 1;
            ['_入稿データURL', 'ファイルアップロード', '入稿データURL'].forEach(key => {
                if (properties[key]) {
                    const urls = properties[key]
                        .replace(/['"]+/g, '')
                        .split(',')
                        .map(u => u.trim())
                        .filter(u => u);
                    if (urls.length > 0) {
                        urls.forEach(url => {
                            properties[`入稿データ ${fileCounter}`] = url;
                            fileCounter++;
                        });
                    }
                    delete properties[key]; // 元のカンマ区切りプロパティを削除
                }
            });

            properties["_bundle_id"] = bundleId;
            properties["_bundle_type"] = "main";

            if (main.id && !skipMainCheck) {
                items.push({ id: main.id, quantity: qty, properties: properties });
            } else {
                console.log("RF: Main Item Skipped (Custom Logic)");
            }

            // Ensure at least one item? Item 4 check comes later.
            // We trust downstream logic picks up Item 4.

            // --- Calculate Item 2 (Paper) ---
            // [Unified Update] Add wood_unified / aluminum_unified
            if (['aluminum_overmat', 'wood_bookmat', 'wood_unified', 'aluminum_unified', 'wood_panel', 'styrene_panel', 'canvas_panel', 'book_matte'].includes(this.formType)) { // [NEW] Canvas Panel
                const paperName = this.elements.paperSelect.value;

                // Logic Split:
                // A. If rf-paper-size-select is visible (Overmat/Bookmat), use it.
                // B. If hidden (Frame Only/Std), we must FIND the variant matching Frame Size (e.g. "A4").

                const paperSizeSelect = this.container.querySelector('#rf-paper-size-select');
                const processingType = this.getProcessingType();
                // [FIX] Only pure 'オーバーマット' or 'ブックマット' allows manual paper size selection
                const isOvermatOrBookmat = (processingType === 'オーバーマット' || processingType === 'ブックマット' || processingType === 'オーバーマット&スチレンパネル裏貼り');

                let paperVariantId = null;

                // [FIX] Always trust paperSizeSelect if it has a value (it is auto-populated even if hidden)
                // or if explicitly selected.
                if (paperSizeSelect && paperSizeSelect.value) {
                    const selectedOpt = paperSizeSelect.options[paperSizeSelect.selectedIndex];
                    paperVariantId = selectedOpt.dataset.id;
                    console.log("RF: Cart Item 2 (Paper) -> From Dropdown ID:", paperVariantId);

                } else if (!isOvermatOrBookmat && paperName) {
                    // Fallback: If Dropdown is empty (e.g. not ready?), try manual match
                    // Matches Frame Size
                    const frameSizeName = this.getEffectiveSizeName(); // e.g. "A4"

                    try {
                        const variants = await this.fetchPaperVariants(paperName);
                        if (variants.length > 0) {
                            // Find variant matching dimensional requirements
                            // Logic: Find SMALLEST paper larger than Frame Size
                            // frameSizeName is the "Effective Key" (e.g. "1000x1000" or "A4").
                            // We need dimensions of THIS Key.
                            const uDims = this.STANDARD_SIZES[frameSizeName];
                            if (uDims) {
                                const uW = Math.min(uDims[0], uDims[1]);
                                const uH = Math.max(uDims[0], uDims[1]);

                                let bestPaper = null;
                                let minPaperArea = Infinity;

                                variants.forEach(v => {
                                    const pDims = this.getDimensionsFromVariantTitle(v.title);
                                    if (!pDims) return;
                                    const pW = pDims[0];
                                    const pH = pDims[1];

                                    if (pW >= uW && pH >= uH) {
                                        const area = pW * pH;
                                        if (area < minPaperArea) {
                                            minPaperArea = area;
                                            bestPaper = v;
                                        }
                                    }
                                });

                                if (bestPaper) {
                                    paperVariantId = bestPaper.id;
                                    console.log(`RF: Cart Item 2 (Paper) -> Auto-Matched by Dim [${frameSizeName}] -> Paper [${bestPaper.title}]`);
                                } else {
                                    console.warn("RF: Paper Variant not found for size (Dim Check):", frameSizeName);
                                }

                            } else {
                                // Fallback to strict name match if dims unknown (unlikely)
                                const match = variants.find(v => v.title === frameSizeName || v.title.startsWith(frameSizeName + ' '));
                                if (match) paperVariantId = match.id;
                            }
                        }
                    } catch (err) {
                        console.error("RF: Error fetching paper for cart:", err);
                    }
                }

                if (paperVariantId) {
                    items.push({
                        id: paperVariantId,
                        quantity: qty,
                        properties: { "_bundle_id": bundleId, "_bundle_parent": "true" }
                    });
                } else {
                    console.warn("RF: Skipping Paper Item (No Variant ID resolved)");
                    // [FIX] Block Submission if Paper is Missing for any framing type (meaning size not supported)
                    // This block is reachable only if formType requires Paper (Item 2)
                    const sizeName = this.getEffectiveSizeName() || '指定サイズ';
                    alert(`選択された用紙には、サイズ「${sizeName}」の取り扱いがありません。\n別の用紙を選択するか、サイズを変更してください。`);
                    this.unlockSubmit(btn);
                    return;
                }
            }

            // --- Calculate Item 4 (Custom Option) ---
            if (this.isCustomMode) {
                const s = parseInt(this.elements.customShort.value);
                const l = parseInt(this.elements.customLong.value);
                const opt = this.getCustomOptionVariant(s, l);
                if (opt) {
                    // [NEW] Capture Colors (Unified/Frame Logic) for Custom Option
                    let customProps = {
                        "_bundle_id": bundleId,
                        // [FIX] If Main Item was skipped (Custom Mode), this Item 4 IS the Main Item.
                        "_bundle_type": skipMainCheck ? "main" : "option",
                        "サイズ詳細": `${s}x${l}mm`
                    };

                    if (skipMainCheck) {
                        // [FIX] If Main, inherit ALL form properties (including renames like 側面テープ)
                        customProps = { ...customProps, ...properties };
                    } else {
                        // Option Mode: Only minimal visual props
                        const fc = document.querySelector('input[name="properties[フレームカラー]"]:checked');
                        if (fc) customProps["フレームカラー"] = fc.value;
                        const mc = document.querySelector('input[name="properties[マットカラー]"]:checked');
                        if (mc) customProps["マットカラー"] = mc.value;
                    }

                    items.push({
                        id: opt.id,
                        quantity: qty,
                        properties: customProps
                    });
                }
            }

            // --- Calculate Item 3 (Test Print) ---
            // [FIX] Removed duplicate legacy block

            // --- Calculate Item 3 (Test Print) ---
            // Section 3.6: Test Print Bundle
            const testPrintCheck = this.container.querySelector('#rf-check-test-print');
            const testPrintData = this.container.querySelector('#rf-test-print-data');

            if (testPrintCheck && testPrintCheck.checked) {
                if (testPrintData && testPrintData.dataset.variantId) {
                    // [FIX] ID 18: Use dynamic quantity from input
                    const tpQtyInput = this.container.querySelector('#rf-tp-qty-input');
                    const tpQty = tpQtyInput ? (parseInt(tpQtyInput.value) || 1) : 1;

                    console.log("RF: Bundling Test Print Item. ID:", testPrintData.dataset.variantId, "Qty:", tpQty);
                    items.push({
                        id: testPrintData.dataset.variantId,
                        quantity: tpQty,
                        properties: {
                            "_bundle_id": bundleId,
                            "_bundle_parent": "true"
                        }
                    });
                } else {
                    console.warn("RF: Test Print Checked but No Variant ID found in #rf-test-print-data");
                    // Do not fallback to hardcoded ID to prevent 422 error.
                }
            }

            // [SAFETY] Filter out invalid items
            const finalItems = items.filter(item => item.id && item.quantity > 0);

            console.log("RF DEBUG: Final ITEMS submitting to Cart:", JSON.parse(JSON.stringify(finalItems))); // [DEBUG]

            try {
                await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: finalItems })
                });

                this._track('rf_add_to_cart', { items: finalItems.length });   // GA4: フォーム帰属の完了(カスタムフォーム経路)

                // [FIX] Open Cart Drawer using Theme's 'show()' method (inherited from DialogElement)
                // Trigger theme events to refresh cart content
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

                // Wait for drawer to refresh before opening (prevents empty drawer)
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    const openDrawer = () => {
                        if (typeof cartDrawer.show === 'function') {
                            cartDrawer.show();
                        } else if (typeof cartDrawer.open === 'function') {
                            cartDrawer.open();
                        }
                    };

                    // Listen for refresh completion
                    const onRefreshed = () => {
                        openDrawer();
                        document.documentElement.removeEventListener('cart-drawer:refreshed', onRefreshed);
                    };
                    document.documentElement.addEventListener('cart-drawer:refreshed', onRefreshed);

                    // Fallback: If refresh event doesn't fire within 1.5s, open anyway
                    setTimeout(() => {
                        openDrawer();
                        document.documentElement.removeEventListener('cart-drawer:refreshed', onRefreshed);
                    }, 1500);

                } else {
                    // Fallback for other drawer types (e.g. standard Shopify themes)
                    const nav = document.querySelector('cart-notification');
                    if (nav) nav.render(finalItems[0]);
                    if (nav && typeof nav.open === 'function') nav.open();
                }

                // Fallback: If no drawer found, do nothing (user can navigate) or show success message?
                // Actually, fetch success is enough for notification?
                this.unlockSubmit(btn);
                btn.textContent = 'カートに追加しました';
                setTimeout(() => btn.textContent = 'カートに入れる', 2000);
            } catch (err) {
                console.error(err);
                alert("カート追加に失敗しました。");
                this.unlockSubmit(btn);
            }
        }

        unlockSubmit(btn) {
            if (btn) { btn.textContent = 'カートに入れる'; btn.disabled = false; }
            this.isSubmitting = false;
        }
    }

    // Expose to global scope for module entry point
    window.CustomOrderForm = CustomOrderForm;
}
